const SOURCE_FILES = {
  F03: "frontend/src/pages/user/Learn.js",
  F08: "docs/xima-knowledge/*.md",
  F10: "frontend/src/pages/user/Lobby.js",
  F11: "frontend/src/pages/user/CreateGame.js",
  F12: "frontend/src/pages/user/Index.js",
  F13: "frontend/src/pages/user/PlayBot.js",
  F14: "frontend/src/pages/user/PlaySandbox.js",
  F16: "frontend/src/pages/user/PlayTournaments.js",
  F17: "frontend/src/pages/user/SpectateMatches.js",
  F18: "frontend/src/pages/user/History.js",
  F19: "frontend/src/pages/user/Stats.js",
  F20: "frontend/src/pages/user/Ranking.js",
  F21: "frontend/src/pages/user/Friends.js",
  F22: "frontend/src/pages/user/FriendProfile.js",
  F23: "frontend/src/pages/user/Store.js",
  F24: "frontend/src/pages/user/DesignMode.js",
  F25: "frontend/src/pages/user/Settings.js",
  F27: "frontend/src/services/voiceControl.js",
  F28: "frontend/src/components/TournamentVoiceChat.js",
  F29: "frontend/src/constants/termsAndConditions.js",
  F30: "frontend/src/constants/skinStoreCatalog.js",
  F31: "frontend/src/components/LoginForm.js; frontend/src/components/RegisterForm.js; frontend/src/components/TermsAcceptanceModal.js; backend/controllers/authController.js; backend/models/User.js",
  F32: "backend/routes/tournament.js; backend/controllers/tournament.js; backend/models/Tournament.js",
  F33: "backend/routes/replay.js; backend/controllers/replayController.js; backend/models/MatchHistory.js",
  F34: "backend/routes/friends.js; backend/controllers/friendsController.js; backend/models/FriendInvite.js; backend/models/Friendship.js",
  F35: "backend/routes/orders.js; backend/controllers/orderController.js; backend/models/GiftCardRewardClaim.js; backend/models/GiftCardRewardConfig.js; backend/models/StorePrice.js",
  F36: "backend/routes/support.js; backend/controllers/supportController.js; backend/models/SupportMessage.js",
  F38: "backend/routes/scienceBot.js; Xima_Game/Assets/Scripts/Core/ScienceBot/ScienceBotMoveSelector.cs",
  F39: "Xima_Game/Assets/Scripts/UI/StartPanel.cs",
  F41: "frontend/public/rules/es/xima-rules.json; Xima_Game/Assets/Scripts/Core/Stage.cs; Xima_Game/Assets/Scripts/Core/Cube.cs; Xima_Game/Assets/Scripts/Player.cs; Xima_Game/Assets/Scripts/Core/TurnsManager.cs",
  F42: "Xima_Game/Assets/Scripts/Dice.cs; Xima_Game/Assets/Scripts/DiceUI.cs; Xima_Game/Assets/Scripts/RandomBot.cs; Xima_Game/Assets/Scripts/CienzarBot.cs",
  F43: "Xima_Game/Assets/Scripts/UI/UIManager.cs; Xima_Game/Assets/Scripts/UI/GameUI.cs; Xima_Game/Assets/Scripts/UI/GameModeDisplay.cs",
  F44: "Xima_Game/Assets/Scripts/Core/OnlineMultiplayerBridge.cs",
  F45: "Xima_Game/Assets/Scripts/CameraOrbit.cs; Xima_Game/Assets/Scripts/Core/VoiceCameraBridge.cs",
  F46: "Xima_Game/Assets/Scripts/UI/SpecialCubeSkinSelectionUI.cs; Xima_Game/Assets/Scripts/Core/SpecialCubeSkinManager.cs; Xima_Game/Assets/Scripts/Core/SpecialCubeSkinApplier.cs",
  F47: "Xima_Game/Assets/Scripts/UI/CIMAX.cs; Xima_Game/Assets/Scripts/UI/PuntuacionCimax.cs; Xima_Game/Assets/Scripts/Core/CimaxTracker.cs; backend/utils/cimaxScoring.js",
  F48: "Xima_Game/Assets/Scripts/SamsungMaliWebGLMaterialFix.cs",
  F49: "frontend/src/services/language.js; frontend/src/i18n.js",
};

const CATEGORY_META = {
  ciencia: {
    label: "Modo Ciencia",
    path: "ciencia",
    headings: ["Base verificada", "Uso practico", "Limite publico"],
  },
  azar: {
    label: "Modo Azar",
    path: "azar",
    headings: ["Base con dados", "Como decidir", "Punto de cuidado"],
  },
  cienzar: {
    label: "Modo Cienzar",
    path: "cienzar",
    headings: ["Estado del modo", "Uso previsto", "Confirmacion pendiente"],
  },
  academia: {
    label: "Academia",
    path: "academia",
    headings: ["Ruta de aprendizaje", "Como practicar", "Revision recomendada"],
  },
  diccionario: {
    label: "Diccionario",
    path: "diccionario",
    headings: ["Definicion", "Uso en XIMA", "Como estudiarlo"],
  },
  articulos: {
    label: "Articulos",
    path: "academia",
    headings: ["Idea central", "Aplicacion en XIMA", "Lectura responsable"],
  },
  solucion: {
    label: "Solucion de problemas",
    path: "solucion-de-problemas",
    headings: ["Problema visible", "Revision segura", "Cuando pedir ayuda"],
  },
  cuenta: {
    label: "Cuenta",
    path: "perfil",
    headings: ["Funcion de cuenta", "Como usarla", "Privacidad"],
  },
  tienda: {
    label: "Tienda",
    path: "tienda",
    headings: ["Elemento visible", "Uso en tienda", "Condiciones pendientes"],
  },
  voz: {
    label: "Voz",
    path: "control-por-voz",
    headings: ["Comando o permiso", "Como usarlo", "Compatibilidad"],
  },
  movil: {
    label: "Movil",
    path: "compatibilidad-movil",
    headings: ["Uso movil", "Como navegar", "Limitacion verificada"],
  },
  replay: {
    label: "Replay",
    path: "historial-y-replay",
    headings: ["Dato del replay", "Como estudiarlo", "Privacidad"],
  },
  progreso: {
    label: "Estadisticas",
    path: "estadisticas",
    headings: ["Metrica visible", "Como interpretarla", "Precaucion"],
  },
  ranking: {
    label: "Ranking",
    path: "ranking",
    headings: ["Tabla visible", "Como leerla", "Revision necesaria"],
  },
  comunidad: {
    label: "Amigos",
    path: "amigos",
    headings: ["Funcion social", "Uso recomendado", "Privacidad"],
  },
  torneos: {
    label: "Torneos",
    path: "torneos",
    headings: ["Funcion competitiva", "Como seguirla", "Pendiente oficial"],
  },
  entrenamiento: {
    label: "Puzzles",
    path: "puzzles",
    headings: ["Entrenamiento visible", "Como practicar", "Limite publico"],
  },
  bots: {
    label: "Bots",
    path: "bots",
    headings: ["Practica con IA", "Como iniciar", "Limite de la guia"],
  },
  glosario: {
    label: "Glosario",
    path: "glosario",
    headings: ["Termino", "Donde aparece", "Relacion"],
  },
};

const sourceRefs = (codes) => (codes || []).map((code) => SOURCE_FILES[code] || code);

const link = (label, path) => ({ label, path });

const faq = (question, answer) => ({ question, answer });

const buildLinks = (route, links) =>
  (links || []).map((item) => ({
    label: item.label,
    path: route(item.path),
  }));

const buildCta = (route, spec, category) => {
  const cta = spec.cta || { label: `Ver ${category.label.toLowerCase()}`, path: category.path };
  return {
    label: cta.label,
    path: route(cta.path),
  };
};

const buildSections = (spec, category) => {
  const headings = spec.headings || category.headings;
  const sections = spec.sections || [
    { heading: headings[0], body: spec.verified },
    { heading: headings[1], body: spec.usage },
    { heading: headings[2], body: spec.caution },
  ];

  return sections;
};

const buildBreadcrumbs = (route, spec, category) => [
  { label: category.label, path: route(category.path) },
  { label: spec.h1, path: route(spec.slug) },
];

const defaultScreenshots = (spec) => [
  `Referencia visual de ${spec.h1}`,
  `Vista relacionada con ${spec.h1} dentro de XIMA`,
];

const buildLearnPage = ({ page, route, canonical }, spec) => {
  const category = CATEGORY_META[spec.category] || CATEGORY_META.academia;
  const status = spec.status || "verified";

  return page({
    slug: spec.slug,
    friendlyUrl: canonical(spec.slug),
    title: spec.title,
    metaDescription: spec.metaDescription,
    h1: spec.h1,
    intro: spec.intro,
    sections: buildSections(spec, category),
    stepsTitle: spec.stepsTitle,
    stepsNote: spec.stepsNote,
    steps: spec.steps || [],
    examples: spec.examples || [],
    screenshots: spec.screenshots || defaultScreenshots(spec),
    faqs: spec.faqs || [],
    internalLinks: buildLinks(route, spec.links),
    cta: buildCta(route, spec, category),
    breadcrumbs: buildBreadcrumbs(route, spec, category),
    sources: sourceRefs(spec.sources),
    status,
    robots: spec.robots || (status === "ownerConfirmation" ? "noindex,follow" : "index,follow"),
    structuredDataType: spec.structuredDataType || (spec.steps?.length > 0 ? "HowTo" : "Article"),
  });
};

const THIRD_HUNDRED_TOPICS = [
  {
    slug: "ciencia/como-se-juega",
    category: "ciencia",
    title: "Como se juega Modo Ciencia en XIMA | Guia oficial verificada",
    metaDescription:
      "Aprende como jugar Modo Ciencia en XIMA usando decisiones libres, reglas base de movimiento y lectura del tablero.",
    h1: "Como se juega Modo Ciencia",
    intro:
      "Modo Ciencia usa el modo free del proyecto: el jugador decide la jugada sin depender de dados visibles.",
    verified:
      "La documentacion interna identifica Ciencia con el modo free y Unity lo mapea como Free; los dados no se muestran para decidir la jugada.",
    usage:
      "Usa este modo para practicar movimiento, altura, bloqueo, captura, rescate y lectura de rutas sin esperar una tirada.",
    caution:
      "Los ejemplos exactos de aperturas o secuencias ganadoras requieren capturas aprobadas antes de publicarse como teoria oficial.",
    steps: [
      "Abre una partida donde el modo seleccionado sea Ciencia.",
      "Observa el tablero antes de mover y ubica tu bloque especial y tus bloques comunes.",
      "Elige si conviene incorporar un bloque nuevo o mover uno que ya esta en juego.",
      "Comprueba que el movimiento respeta linea recta, tablero y altura permitida.",
      "Confirma la jugada solo cuando la ruta no dependa de dados ni de una tirada visible.",
    ],
    examples: [
      "Puedes mover un bloque comun para abrir una ruta hacia la cima sin esperar dados.",
      "Si el bloque especial esta amenazado, puedes priorizar defensa o rescate segun la posicion.",
    ],
    faqs: [
      faq("Ciencia usa dados?", "No. La fuente del proyecto indica que en este modo no se muestran dados para decidir la jugada."),
      faq("Cambian las reglas base?", "No. Se mantienen tablero, bloques, movimiento, captura y rescate."),
    ],
    links: [
      link("Modo Ciencia", "ciencia"),
      link("Sistema de movimientos", "reglas/movimientos"),
      link("Como jugar XIMA", "como-jugar"),
    ],
    cta: { label: "Ver reglas de movimiento", path: "reglas/movimientos" },
    sources: ["F08", "F10", "F11", "F39", "F41", "F43"],
  },
  {
    slug: "ciencia/reglas",
    category: "ciencia",
    title: "Reglas de Modo Ciencia en XIMA | Sin dados visibles",
    metaDescription:
      "Consulta las reglas verificadas de Modo Ciencia: decision libre, movimiento base y limites publicos de la guia.",
    h1: "Reglas de Modo Ciencia",
    intro:
      "Las reglas de Ciencia se explican como una aplicacion del reglamento base sin dados visibles.",
    verified:
      "Ciencia mantiene el objetivo de llevar el bloque especial a la cima y conserva las reglas comunes de incorporacion, movimiento, captura y rescate.",
    usage:
      "Antes de mover, revisa si tu bloque puede entrar, subir, bajar o desplazarse en linea recta sin romper las restricciones del tablero.",
    caution:
      "El incremento de material y otros casos finos deben confirmarse con el propietario antes de ampliarse con ejemplos publicos.",
    steps: [
      "Selecciona una partida en Modo Ciencia.",
      "Lee la posicion actual y separa bloques comunes de bloque especial.",
      "Decide entre incorporar o mover segun el turno.",
      "Valida que el destino este dentro del tablero y respete la altura maxima permitida.",
      "Usa el replay despues de jugar para revisar si la jugada cumplio las reglas.",
    ],
    examples: [
      "Un bloque comun puede ayudar a rescatar al especial si este fue capturado.",
      "Un bloque especial no puede subir ni pasar sobre otro bloque especial.",
    ],
    faqs: [
      faq("La guia inventa reglas exclusivas de Ciencia?", "No. Resume solo reglas base y el dato verificado de que no depende de dados visibles."),
      faq("Donde se revisa una jugada dudosa?", "El historial y el replay permiten estudiar la secuencia cuando la partida queda registrada."),
    ],
    links: [
      link("Reglas de XIMA", "reglas"),
      link("Tablero y casillas", "reglas/tablero-y-casillas"),
      link("Historial y replay", "historial-y-replay"),
    ],
    cta: { label: "Ver Modo Ciencia", path: "ciencia" },
    sources: ["F08", "F41", "F43"],
    status: "partial",
  },
  {
    slug: "ciencia/errores-frecuentes",
    category: "ciencia",
    title: "Errores frecuentes en Modo Ciencia | XIMA",
    metaDescription:
      "Revisa errores comunes al jugar Ciencia en XIMA: rutas invalidas, altura, bloque especial y decisiones de turno.",
    h1: "Errores frecuentes en Modo Ciencia",
    intro:
      "En Ciencia los errores suelen venir de leer mal una ruta, una altura o el objetivo del bloque especial.",
    verified:
      "El proyecto valida reglas de movimiento y conserva la distincion entre incorporar y mover; esas reglas explican muchos rechazos de jugada.",
    usage:
      "Usa esta guia para revisar una jugada antes de confirmarla y para estudiar una partida ya terminada desde el replay.",
    caution:
      "No se publican codigos internos de rechazo ni detalles de validacion que puedan facilitar abuso del sistema online.",
    steps: [
      "Comprueba si el bloque estaba fuera del tablero o ya estaba en juego.",
      "Revisa si la ruta avanza en una sola linea vertical, horizontal o diagonal.",
      "Verifica que el destino no rompa la altura maxima permitida para subir o bajar.",
      "Confirma si el bloque especial esta intentando subir o pasar sobre otro especial.",
      "Abre el replay si existe y compara la secuencia con las reglas publicas.",
    ],
    examples: [
      "Mover como si fuera incorporacion puede producir una decision invalida.",
      "Intentar una ruta que cambia de direccion durante la misma jugada no coincide con la regla de linea recta.",
    ],
    faqs: [
      faq("Todos los errores son fallos del juego?", "No. Muchos rechazos corresponden a reglas de movimiento o posicion."),
      faq("Puedo reportar una discrepancia?", "Si. Usa soporte cuando la interfaz no coincida con las reglas verificadas."),
    ],
    links: [
      link("Movimiento no permitido", "solucion/movimiento-no-permitido"),
      link("Jugada legal", "reglas/jugada-legal"),
      link("Replay", "historial-y-replay"),
    ],
    cta: { label: "Ver solucion de problemas", path: "solucion-de-problemas" },
    sources: ["F08", "F41", "F44", "F33"],
  },
  {
    slug: "ciencia/analizar-partidas",
    category: "ciencia",
    title: "Analizar partidas de Ciencia en XIMA | Replay y anotacion",
    metaDescription:
      "Aprende a revisar partidas de Modo Ciencia con historial, replay, timeline y sistema de anotacion de XIMA.",
    h1: "Analizar partidas de Ciencia",
    intro:
      "Una partida de Ciencia puede estudiarse desde historial y replay cuando la repeticion esta disponible.",
    verified:
      "El proyecto incluye historial, replay, controles de reproduccion, timeline y anotacion para revisar partidas registradas.",
    usage:
      "Analiza turnos clave: incorporaciones, movimientos largos, capturas, rescates y rutas hacia la cima.",
    caution:
      "Los replays publicos no deben exponer datos privados de jugadores; usa ejemplos anonimos o aprobados.",
    steps: [
      "Abre Historial o Ver partidos y localiza una partida de Ciencia con replay disponible.",
      "Pulsa Ver replay o Reproducir cuando la tarjeta lo muestre.",
      "Avanza por la timeline y detente en cambios de posicion importantes.",
      "Compara cada movimiento con la anotacion y con las reglas de movimiento.",
      "Anota que decision repetirias o evitarias en una futura partida de Ciencia.",
    ],
    examples: [
      "Una secuencia donde un bloque comun abre paso al especial puede revisarse turno por turno.",
      "Un rescate fallido puede estudiarse mirando la altura y la columna antes de la jugada.",
    ],
    faqs: [
      faq("Necesito datos de dados para analizar Ciencia?", "No. En Ciencia el foco esta en la decision libre y la posicion."),
      faq("Que pasa si no hay replay?", "La interfaz puede mostrar que no hay replay guardado para esa partida."),
    ],
    links: [
      link("Historial y replay", "historial-y-replay"),
      link("Sistema de anotacion", "sistema-de-anotacion"),
      link("Controles replay", "replay/controles"),
    ],
    cta: { label: "Ver sistema de anotacion", path: "sistema-de-anotacion" },
    sources: ["F08", "F18", "F33", "F41"],
  },
  {
    slug: "ciencia/entrenar-ia",
    category: "ciencia",
    title: "Entrenar contra IA en Modo Ciencia | XIMA",
    metaDescription:
      "Aprende como practicar Modo Ciencia contra bot en XIMA sin inventar funciones no confirmadas.",
    h1: "Entrenar IA en Ciencia",
    intro:
      "XIMA incluye flujos de bot e inteligencia artificial que pueden usarse para practicar decisiones de tablero.",
    verified:
      "El repositorio contiene pantalla de Jugar con bot y rutas de cienciaBot, ademas de selector de movimientos para el bot de Ciencia.",
    usage:
      "La practica con bot sirve para repetir lectura de tablero, movimientos y respuestas sin depender de otro jugador conectado.",
    caution:
      "No se debe afirmar nivel educativo, fuerza de IA o comportamiento exacto del bot sin pruebas publicas y aprobacion del propietario.",
    steps: [
      "Abre Jugar con bot desde la interfaz de XIMA.",
      "Selecciona un modo compatible con practica de Ciencia cuando aparezca disponible.",
      "Elige la dificultad visible en la pantalla antes de iniciar.",
      "Juega turnos completos revisando incorporacion, movimiento y ruta a la cima.",
      "Despues de terminar, usa historial o estadisticas si la partida queda registrada.",
    ],
    examples: [
      "Practicar con bot ayuda a comprobar si una ruta hacia la cima queda bloqueada.",
      "Cambiar dificultad puede modificar la experiencia, pero la guia no promete fuerza exacta de la IA.",
    ],
    faqs: [
      faq("El bot sustituye a una partida online?", "No. Es una forma de practica visible en la plataforma."),
      faq("La dificultad esta confirmada?", "La interfaz contiene dificultad, pero su comportamiento exacto debe tratarse con cautela."),
    ],
    links: [
      link("Bots", "bots"),
      link("Dificultad de bot", "bots/dificultad"),
      link("Modo Ciencia", "ciencia"),
    ],
    cta: { label: "Ver bots", path: "bots" },
    sources: ["F13", "F38", "F41"],
    status: "partial",
  },
  {
    slug: "ciencia/faq",
    category: "ciencia",
    title: "FAQ Modo Ciencia XIMA | Preguntas frecuentes",
    metaDescription:
      "Respuestas verificadas sobre Modo Ciencia en XIMA: dados, reglas base, replay y practica.",
    h1: "FAQ Modo Ciencia",
    intro:
      "Estas respuestas resumen lo que el proyecto permite afirmar publicamente sobre Ciencia.",
    verified:
      "Ciencia corresponde al modo free y se diferencia de Azar porque no muestra dados para decidir la jugada.",
    usage:
      "Consulta esta FAQ cuando necesites separar reglas base de afirmaciones todavia pendientes de confirmacion.",
    caution:
      "Las estrategias avanzadas, aperturas y promesas de rendimiento quedan fuera hasta que existan documentos oficiales.",
    steps: [
      "Lee primero la diferencia entre Ciencia y Azar.",
      "Revisa las reglas generales antes de buscar casos avanzados.",
      "Usa la pagina de movimientos para resolver dudas de rutas.",
      "Consulta replay y anotacion si la duda viene de una partida real.",
      "Contacta soporte si la interfaz no coincide con una regla verificada.",
    ],
    examples: [
      "Pregunta valida: si Ciencia usa dados. Respuesta verificada: no para decidir la jugada visible.",
      "Pregunta pendiente: apertura ideal. Respuesta prudente: necesita material oficial aprobado.",
    ],
    faqs: [
      faq("Modo Ciencia es el modo free?", "Si. Asi aparece documentado en frontend, backend y Unity."),
      faq("Puedo estudiar Ciencia con replay?", "Si, siempre que la partida tenga replay disponible."),
    ],
    links: [
      link("Ciencia", "ciencia"),
      link("Azar", "azar"),
      link("Reglas", "reglas"),
    ],
    cta: { label: "Ver Modo Ciencia", path: "ciencia" },
    sources: ["F08", "F10", "F11", "F39"],
  },
  {
    slug: "azar/dados",
    category: "azar",
    title: "Dados en Modo Azar XIMA | Como leer una tirada",
    metaDescription:
      "Conoce como los dados forman parte de Modo Azar en XIMA y como revisar la tirada antes de mover.",
    h1: "Dados en Modo Azar",
    intro:
      "Modo Azar usa dados y el resultado afecta el movimiento disponible durante la partida.",
    verified:
      "Los scripts de Unity incluyen dados con resultados de 1 a 6 y la documentacion interna asocia Azar con el modo Dice.",
    usage:
      "Lee el resultado visible antes de mover y relaciona la tirada con una ruta valida dentro del tablero.",
    caution:
      "No se publican combinaciones oficiales de dados hasta validar ejemplos completos en Unity.",
    steps: [
      "Inicia o abre una partida en Modo Azar.",
      "Espera el momento de lanzar o leer los dados visibles.",
      "Observa los valores antes de seleccionar un bloque.",
      "Busca una ruta que use la tirada sin salir del tablero ni romper alturas.",
      "Confirma la jugada y revisa el replay si necesitas estudiar la decision.",
    ],
    examples: [
      "Una tirada puede orientar cuantos pasos considerar antes de seleccionar destino.",
      "Si la ruta no es legal, revisa altura, direccion y posicion del bloque.",
    ],
    faqs: [
      faq("Los dados son parte de todos los modos?", "No. Estan asociados al modo Azar y a modos hibridos pendientes de confirmacion fina."),
      faq("Los dados van de 1 a 6?", "Los scripts verificados generan valores entre 1 y 6."),
    ],
    links: [
      link("Modo Azar", "azar"),
      link("Lanzar dados", "tutoriales/lanzar-dados"),
      link("Reglas de dados", "reglas/dados"),
    ],
    cta: { label: "Ver Modo Azar", path: "azar" },
    sources: ["F08", "F42", "F43"],
  },
  {
    slug: "azar/probabilidad-decisiones",
    category: "azar",
    title: "Probabilidad y decisiones en Modo Azar | XIMA",
    metaDescription:
      "Aprende a tomar decisiones prudentes en Modo Azar leyendo dados, tablero y riesgos sin promesas no verificadas.",
    h1: "Probabilidad y decisiones",
    intro:
      "Azar combina lectura del tablero con el resultado de dados, por eso conviene evaluar riesgo antes de mover.",
    verified:
      "El proyecto confirma que Azar usa dados y mantiene reglas base; la probabilidad se presenta aqui como criterio de lectura, no como formula oficial.",
    usage:
      "Compara la tirada con las rutas disponibles y evita seleccionar un movimiento solo por estar cerca de la cima.",
    caution:
      "No se publican porcentajes ni consejos matematicos como garantia de victoria.",
    steps: [
      "Lee los dados visibles de la partida.",
      "Lista mentalmente los bloques que pueden usar esa tirada con una ruta legal.",
      "Descarta rutas que dejen el especial expuesto o atrapado.",
      "Prioriza movimientos que mantengan opciones para el turno siguiente.",
      "Revisa la decision en replay si la partida queda registrada.",
    ],
    examples: [
      "Una tirada alta no siempre conviene si termina en una columna dominada.",
      "Una tirada corta puede servir para mejorar defensa o preparar rescate.",
    ],
    faqs: [
      faq("Esta pagina da probabilidades exactas?", "No. Solo explica una forma prudente de leer riesgo con dados."),
      faq("Azar elimina la estrategia?", "No. El jugador sigue tomando decisiones dentro de reglas de tablero y movimiento."),
    ],
    links: [
      link("Dados en XIMA", "azar/dados"),
      link("Diccionario de riesgo", "diccionario/riesgo"),
      link("Modo Azar", "azar"),
    ],
    cta: { label: "Ver dados en Azar", path: "azar/dados" },
    sources: ["F08", "F42", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "azar/faq",
    category: "azar",
    title: "FAQ Modo Azar XIMA | Dados y decisiones",
    metaDescription:
      "Preguntas frecuentes sobre Modo Azar en XIMA: dados, movimiento, replay y limites de reglas publicas.",
    h1: "FAQ Modo Azar",
    intro:
      "Estas respuestas aclaran lo confirmado sobre el modo con dados de XIMA.",
    verified:
      "Modo Azar corresponde al modo dice en frontend/backend y Dice en Unity.",
    usage:
      "Usa esta FAQ para entender que depende de dados y que sigue dependiendo de reglas de tablero.",
    caution:
      "Los ejemplos de tiradas completas deben revisarse en una partida real antes de convertirse en diagramas oficiales.",
    steps: [
      "Revisa primero que la partida sea Modo Azar.",
      "Lee la tirada visible o el evento de dados en la interfaz.",
      "Consulta las reglas de movimiento para validar destino.",
      "Usa replay para revisar una tirada despues de la partida.",
      "Pide soporte si los dados no aparecen en un modo donde deberian mostrarse.",
    ],
    examples: [
      "Azar puede mostrar valores de dados en la linea de tiempo del replay.",
      "Una jugada rechazada puede deberse a movimiento invalido, no al dado.",
    ],
    faqs: [
      faq("Azar usa dados?", "Si. Esa es la diferencia central verificada del modo."),
      faq("Los dados se documentan igual que las reglas?", "Se documentan de forma prudente hasta confirmar ejemplos completos."),
    ],
    links: [
      link("Modo Azar", "azar"),
      link("Solucion dados no aparecen", "solucion/dados-no-aparecen"),
      link("Sistema de movimientos", "reglas/movimientos"),
    ],
    cta: { label: "Ver solucion de dados", path: "solucion/dados-no-aparecen" },
    sources: ["F08", "F42", "F43"],
  },
  {
    slug: "cienzar/ciencia-y-azar",
    category: "cienzar",
    title: "Cienzar: Ciencia y Azar en XIMA | Pendiente de confirmacion",
    metaDescription:
      "Pagina prudente sobre Cienzar en XIMA, marcada noindex hasta confirmar las reglas publicas del modo hibrido.",
    h1: "Cienzar: Ciencia y Azar",
    intro:
      "Cienzar aparece en el proyecto como modo hibrido, pero su explicacion publica completa necesita confirmacion.",
    verified:
      "La interfaz y el codigo contienen referencias a Cienzar, ademas de bots y estadisticas por modo.",
    usage:
      "La pagina sirve como borrador controlado para enlazar lo confirmado sin publicar reglas finas no aprobadas.",
    caution:
      "No se deben explicar alternancias, ventajas, dados o estrategia final de Cienzar sin validacion del propietario.",
    steps: [
      "Identifica Cienzar solo como modo visible o referido por el proyecto.",
      "Consulta Ciencia y Azar por separado para entender las bases verificadas.",
      "Evita usar ejemplos de turno hibrido sin captura o regla oficial aprobada.",
      "Marca cualquier explicacion avanzada como pendiente.",
      "Espera confirmacion antes de indexar esta pagina en buscadores.",
    ],
    examples: [
      "Es valido decir que Cienzar aparece como modo en la plataforma.",
      "No es valido inventar cuando se decide por ciencia o por azar.",
    ],
    faqs: [
      faq("Esta pagina puede posicionarse en Google?", "No. Se mantiene noindex hasta confirmar reglas publicas."),
      faq("Por que existe entonces?", "Para ordenar conocimiento interno y evitar respuestas inventadas."),
    ],
    links: [
      link("Modo Cienzar", "cienzar"),
      link("Modo Ciencia", "ciencia"),
      link("Modo Azar", "azar"),
    ],
    cta: { label: "Ver Modo Cienzar", path: "cienzar" },
    sources: ["F08", "F10", "F11", "F42"],
    status: "ownerConfirmation",
  },
  {
    slug: "cienzar/faq",
    category: "cienzar",
    title: "FAQ Cienzar XIMA | Preguntas pendientes de confirmacion",
    metaDescription:
      "FAQ controlada sobre Cienzar en XIMA, noindex hasta que las reglas del modo hibrido esten aprobadas.",
    h1: "FAQ Cienzar",
    intro:
      "Cienzar necesita una FAQ separada porque hay referencias reales, pero no todas las reglas estan listas para publicarse.",
    verified:
      "El modo aparece en UI, ranking, estadisticas y bots, lo suficiente para registrarlo como tema pendiente.",
    usage:
      "Usa esta pagina para responder solo con estado, fuentes y limites, sin convertir hipotesis en reglas.",
    caution:
      "No publicar recomendaciones competitivas, condiciones de victoria diferenciadas ni flujo exacto sin confirmacion humana.",
    steps: [
      "Comprueba si la pregunta trata de existencia del modo o de reglas finas.",
      "Responde existencia del modo con fuentes verificadas.",
      "Deriva reglas base a las paginas de Ciencia, Azar y reglas generales.",
      "Marca cualquier detalle no confirmado como pendiente.",
      "Mantiene noindex mientras falte aprobacion editorial.",
    ],
    examples: [
      "Pregunta segura: si Cienzar existe en el producto. Respuesta: si aparece referenciado.",
      "Pregunta pendiente: estrategia exacta del modo. Respuesta: requiere confirmacion.",
    ],
    faqs: [
      faq("Por que Cienzar no esta indexado?", "Porque faltan reglas publicas aprobadas para explicarlo completo."),
      faq("Puedo jugarlo si aparece en la interfaz?", "La pagina solo documenta la existencia visible; el uso final debe verificarse en la plataforma."),
    ],
    links: [
      link("Cienzar como modo hibrido", "modos/cienzar-ciencia-y-azar"),
      link("Ciencia V/S Azar", "modos/ciencia-vs-azar"),
      link("Modos de juego", "modos-de-juego"),
    ],
    cta: { label: "Ver modos de juego", path: "modos-de-juego" },
    sources: ["F08", "F10", "F11", "F13", "F19", "F20"],
    status: "ownerConfirmation",
  },
  {
    slug: "academia/principiantes",
    category: "academia",
    title: "Academia XIMA para principiantes | Ruta inicial",
    metaDescription:
      "Ruta de aprendizaje para empezar en XIMA: objetivo, bloques, movimientos, crear partida y revisar replay.",
    h1: "Academia para principiantes",
    intro:
      "Esta ruta organiza las guias basicas para que un jugador nuevo aprenda sin saltar directo a conceptos avanzados.",
    verified:
      "Aprender contiene reglas, videos, glosario, guias de partida, replay y documentos internos que respaldan una ruta inicial.",
    usage:
      "Sigue el orden recomendado: objetivo, bloques, movimientos, modos, partida y revision posterior.",
    caution:
      "La ruta no reemplaza reglas oficiales; enlaza a ellas para validar cada accion.",
    steps: [
      "Empieza con Que es XIMA y objetivo del juego.",
      "Lee bloques comunes, bloque especial y cima.",
      "Continua con sistema de movimientos y jugada legal.",
      "Crea o unete a una partida sencilla.",
      "Revisa historial y replay para aprender de la primera experiencia.",
    ],
    examples: [
      "Un principiante puede empezar por Ciencia para aislar movimiento sin dados.",
      "Despues de jugar, el replay ayuda a distinguir error de movimiento y decision estrategica.",
    ],
    faqs: [
      faq("Que guia leo primero?", "Que es XIMA y Como jugar son las entradas mas directas."),
      faq("Necesito jugar online al principio?", "No necesariamente; tambien existen practica con bot y FreeBox."),
    ],
    links: [
      link("Que es XIMA", "que-es-xima"),
      link("Como jugar", "como-jugar"),
      link("Crear partida", "tutoriales/crear-partida"),
    ],
    cta: { label: "Ver como jugar", path: "como-jugar" },
    sources: ["F03", "F08", "F41"],
  },
  {
    slug: "academia/intermedio",
    category: "academia",
    title: "Academia XIMA intermedia | Replay, tactica y decisiones",
    metaDescription:
      "Ruta intermedia para estudiar XIMA con replay, anotacion, estadisticas, ranking y conceptos de estrategia.",
    h1: "Academia intermedia",
    intro:
      "La ruta intermedia se centra en analizar partidas y tomar decisiones con mas contexto.",
    verified:
      "La plataforma incluye historial, replay, anotacion, estadisticas, ranking y diccionario, que permiten una ruta de estudio mas avanzada.",
    usage:
      "Combina teoria de reglas con revision de partidas reales y lectura de metricas visibles.",
    caution:
      "No interpretes CIMAX, ranking o rachas como diagnostico absoluto de nivel; son datos del producto con contexto limitado.",
    steps: [
      "Repasa movimientos, rescate y jugada legal.",
      "Abre una partida propia en Historial.",
      "Usa pausa, velocidad y timeline para revisar turnos clave.",
      "Compara decisiones con conceptos de tactica, defensa y posicion.",
      "Consulta estadisticas y ranking como complemento, no como unica lectura.",
    ],
    examples: [
      "Una derrota puede convertirse en leccion si detectas el turno donde perdiste control de la cima.",
      "Una racha positiva puede revisarse junto al modo jugado y no solo como numero aislado.",
    ],
    faqs: [
      faq("Que diferencia esta ruta de principiantes?", "Aqui el foco pasa de conocer reglas a analizar decisiones."),
      faq("Necesito capturas oficiales?", "Para publicar ejemplos visuales si; para estudiar tu partida basta el replay disponible."),
    ],
    links: [
      link("Replay", "historial-y-replay"),
      link("Sistema de anotacion", "sistema-de-anotacion"),
      link("Diccionario de tactica", "diccionario/tactica"),
    ],
    cta: { label: "Ver historial y replay", path: "historial-y-replay" },
    sources: ["F08", "F18", "F19", "F20", "F33"],
  },
  {
    slug: "academia/lecciones",
    category: "academia",
    title: "Lecciones XIMA | Orden recomendado para aprender",
    metaDescription:
      "Organiza tus lecciones de XIMA por reglas, modos, partidas, replay, estadisticas, tienda y soporte.",
    h1: "Lecciones XIMA",
    intro:
      "Las lecciones funcionan como un indice de estudio: agrupan guias que ya existen dentro de Aprender.",
    verified:
      "La seccion Aprender muestra videos, reglas, indice completo, biblioteca y guias SEO conectadas por categorias.",
    usage:
      "Usa las lecciones para elegir un tema y pasar a una guia especifica con pasos, ejemplos y enlaces internos.",
    caution:
      "No se presenta como curso con certificacion ni progreso automatizado porque esa funcion publica no esta verificada.",
    steps: [
      "Abre el indice completo de Aprender.",
      "Usa el buscador interno con palabras completas como replay, tienda, voz o partida.",
      "Abre el grupo desplegable relacionado con tu tema.",
      "Lee la explicacion verificada y los pasos de la guia.",
      "Vuelve al indice para continuar con una guia relacionada.",
    ],
    examples: [
      "Para aprender partidas, abre Partidas e interfaz y sigue crear, buscar y unirse.",
      "Para estudiar despues de jugar, abre Historial, replay y anotacion.",
    ],
    faqs: [
      faq("Las lecciones son paginas separadas?", "Son guias organizadas por temas dentro de Aprender."),
      faq("El buscador acepta frases?", "Si. El buscador prioriza palabras completas y resultados relacionados."),
    ],
    links: [
      link("Aprender XIMA", "que-es-xima"),
      link("Academia principiantes", "academia/principiantes"),
      link("Glosario", "glosario"),
    ],
    cta: { label: "Ver academia", path: "academia" },
    sources: ["F03", "F04"],
  },
  {
    slug: "academia/ejercicios",
    category: "academia",
    title: "Ejercicios XIMA | Practica con reglas, puzzles y replay",
    metaDescription:
      "Ideas verificadas para practicar XIMA usando puzzles, FreeBox, bot y replay sin inventar ejercicios oficiales.",
    h1: "Ejercicios XIMA",
    intro:
      "Los ejercicios de Academia se apoyan en funciones reales: puzzles, FreeBox, bot, reglas y replay.",
    verified:
      "El proyecto contiene puzzles, modo de practica FreeBox, juego con bot y replay para revisar partidas.",
    usage:
      "Elige un objetivo concreto por sesion: rutas, altura, rescate, dados, replay o lectura de posicion.",
    caution:
      "Los ejercicios no prometen recompensas ni progreso certificado salvo que la interfaz lo muestre y este confirmado.",
    steps: [
      "Escoge una funcion de practica: puzzle, FreeBox o bot.",
      "Define el foco de la sesion, por ejemplo mover en linea recta o leer la cima.",
      "Juega pocos turnos o un puzzle completo.",
      "Revisa el resultado con reglas y replay cuando exista.",
      "Anota el error principal antes de pasar a otro ejercicio.",
    ],
    examples: [
      "Un ejercicio de altura consiste en buscar destinos validos sin cambiar de direccion.",
      "Un ejercicio de replay consiste en pausar antes de una captura y explicar por que ocurrio.",
    ],
    faqs: [
      faq("Hay ejercicios oficiales completos?", "Esta pagina solo organiza practicas apoyadas en funciones existentes."),
      faq("Puzzles y FreeBox son lo mismo?", "No. Puzzles son retos; FreeBox es practica libre documentada por separado."),
    ],
    links: [
      link("Puzzles", "puzzles"),
      link("FreeBox", "modos/freebox"),
      link("Bots", "bots"),
    ],
    cta: { label: "Ver puzzles", path: "puzzles" },
    sources: ["F08", "F12", "F13", "F14"],
    status: "partial",
  },
  {
    slug: "academia/analisis-partidas",
    category: "academia",
    title: "Analisis de partidas XIMA | Metodo con replay",
    metaDescription:
      "Aprende a analizar una partida de XIMA paso a paso usando replay, timeline, anotacion y reglas verificadas.",
    h1: "Analisis de partidas",
    intro:
      "Analizar una partida significa reconstruir decisiones visibles sin publicar datos privados de otros jugadores.",
    verified:
      "Historial, replay, timeline, controles de velocidad y anotacion aparecen en la documentacion y en el frontend.",
    usage:
      "El metodo recomendado es revisar turnos criticos, no repetir toda la partida sin objetivo.",
    caution:
      "Los ejemplos publicos deben anonimizar jugadores o usar material aprobado.",
    steps: [
      "Abre una partida con replay disponible.",
      "Reproduce hasta el primer cambio importante de posicion.",
      "Pausa y revisa que bloque se movio y desde donde.",
      "Compara la jugada con reglas de movimiento y objetivo.",
      "Resume una mejora concreta para la siguiente partida.",
    ],
    examples: [
      "Si una ruta a la cima fallo, revisa el turno anterior y la columna que la bloqueo.",
      "Si una captura cambio la partida, mira que bloque quedo encima y que piezas quedaron dominadas.",
    ],
    faqs: [
      faq("Analizar partida requiere estadisticas?", "No. Las estadisticas ayudan, pero el replay y la anotacion son suficientes para empezar."),
      faq("Puedo compartir cualquier replay?", "No. Comparte solo contenido permitido y sin datos privados."),
    ],
    links: [
      link("Analizar partida paso a paso", "articulos/analizar-partida-paso-a-paso"),
      link("Eventos de replay", "replay/eventos"),
      link("Leer anotacion", "replay/leer-anotacion"),
    ],
    cta: { label: "Ver replay", path: "historial-y-replay" },
    sources: ["F08", "F18", "F33"],
  },
  {
    slug: "diccionario/estrategia",
    category: "diccionario",
    title: "Estrategia en XIMA | Diccionario de aprendizaje",
    metaDescription:
      "Definicion de estrategia aplicada a XIMA con ejemplos de tablero, decisiones y enlaces a guias relacionadas.",
    h1: "Estrategia",
    intro:
      "En XIMA, estrategia es planificar decisiones de tablero pensando en objetivo, rutas, defensa y turnos futuros.",
    verified:
      "Las reglas de XIMA obligan a leer movimiento, altura, bloque especial y cima; esos elementos sostienen la planificacion.",
    usage:
      "Usa estrategia para decidir donde crear presencia, cuando proteger el especial y cuando buscar la cima.",
    caution:
      "No se publican aperturas oficiales ni planes ganadores garantizados.",
    steps: [
      "Identifica el objetivo de la posicion.",
      "Ubica bloque especial, bloques comunes y cima.",
      "Evalua que rutas pueden abrirse o cerrarse en el turno actual.",
      "Anticipa una respuesta probable del rival o del bot.",
      "Elige la jugada que conserve opciones y respete reglas.",
    ],
    examples: [
      "Proteger el bloque especial puede ser mas estrategico que avanzar sin apoyo.",
      "Crear una ruta con bloques comunes puede preparar una llegada futura a la cima.",
    ],
    faqs: [
      faq("Estrategia y tactica son lo mismo?", "No. Estrategia mira el plan general; tactica resuelve una situacion concreta."),
      faq("XIMA tiene teoria oficial de aperturas?", "No publicada en esta base sin confirmacion del propietario."),
    ],
    links: [
      link("Tactica", "diccionario/tactica"),
      link("Planificacion", "diccionario/planificacion"),
      link("Modo Ciencia", "ciencia"),
    ],
    cta: { label: "Ver tactica", path: "diccionario/tactica" },
    sources: ["F08", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/tactica",
    category: "diccionario",
    title: "Tactica en XIMA | Diccionario de estrategia",
    metaDescription:
      "Aprende que significa tactica en XIMA y como se relaciona con movimientos, captura, defensa y replay.",
    h1: "Tactica",
    intro:
      "La tactica es una solucion concreta para una posicion: mover, bloquear, capturar, rescatar o preparar la cima.",
    verified:
      "Las reglas de movimiento, dominacion, captura y rescate permiten explicar tacticas sin inventar teoria externa.",
    usage:
      "Busca tacticas cuando una jugada inmediata cambia el estado de una columna o la seguridad del especial.",
    caution:
      "Los nombres de combinaciones tacticas deben aprobarse antes de convertirse en terminologia oficial.",
    steps: [
      "Mira que bloque propio puede actuar ahora.",
      "Detecta amenazas sobre el bloque especial.",
      "Revisa si una columna puede dominarse o liberarse.",
      "Comprueba que la jugada sea legal antes de confirmarla.",
      "Reproduce el turno despues para ver si la tactica funciono.",
    ],
    examples: [
      "Mover un comun para liberar un bloque dominado puede ser una tactica defensiva.",
      "Bloquear una ruta directa a la cima puede cambiar el plan del rival.",
    ],
    faqs: [
      faq("La tactica depende del modo?", "Las reglas base aplican a todos; Azar agrega lectura de dados."),
      faq("Como estudio tactica?", "Usa replay, pausa y anotacion para aislar un turno clave."),
    ],
    links: [
      link("Estrategia", "diccionario/estrategia"),
      link("Defensa", "diccionario/defensa"),
      link("Replay", "historial-y-replay"),
    ],
    cta: { label: "Ver replay", path: "historial-y-replay" },
    sources: ["F08", "F41", "F33"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/planificacion",
    category: "diccionario",
    title: "Planificacion en XIMA | Pensar varios turnos",
    metaDescription:
      "Definicion de planificacion aplicada a XIMA: rutas, turnos, bloque especial, altura y replay.",
    h1: "Planificacion",
    intro:
      "Planificar en XIMA es decidir con el turno actual sin perder de vista rutas futuras hacia la cima.",
    verified:
      "El tablero por niveles, las reglas de movimiento y el objetivo de la cima hacen que la posicion futura importe.",
    usage:
      "Antes de mover, piensa que casilla deja mejor acceso, defensa o rescate en el turno siguiente.",
    caution:
      "No se garantiza que un plan funcione; el rival, el modo y los dados pueden cambiar la posicion.",
    steps: [
      "Define si tu prioridad es ataque, defensa o rescate.",
      "Ubica una ruta posible hacia la cima o hacia una columna clave.",
      "Comprueba que el primer movimiento del plan sea legal.",
      "Calcula que respuesta podria cerrar esa ruta.",
      "Ajusta el plan despues de cada turno real.",
    ],
    examples: [
      "Incorporar un bloque puede ser mejor que avanzar si abre una segunda ruta.",
      "En Azar, planificar incluye aceptar que la siguiente tirada puede cambiar opciones.",
    ],
    faqs: [
      faq("Planificar es solo para Ciencia?", "No. Tambien sirve en Azar, aunque los dados agregan incertidumbre."),
      faq("Como reviso si planee bien?", "Usa replay para comparar intencion y resultado."),
    ],
    links: [
      link("Anticipacion", "diccionario/anticipacion"),
      link("Como planificar movimientos", "articulos/planificar-varios-movimientos"),
      link("Reglas de turnos", "reglas/turnos"),
    ],
    cta: { label: "Ver anticipacion", path: "diccionario/anticipacion" },
    sources: ["F08", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/anticipacion",
    category: "diccionario",
    title: "Anticipacion en XIMA | Diccionario",
    metaDescription:
      "Que significa anticipacion en XIMA y como usarla para leer respuestas, rutas y riesgos.",
    h1: "Anticipacion",
    intro:
      "Anticipar es imaginar que puede pasar despues de tu jugada, sin convertir la prediccion en certeza.",
    verified:
      "El sistema por turnos y las reglas de movimiento permiten revisar consecuencias antes de confirmar una accion.",
    usage:
      "Anticipa que piezas quedaran libres, dominadas o cerca de la cima luego de mover.",
    caution:
      "En modos con dados, la anticipacion debe aceptar variacion; no hay prediccion exacta garantizada.",
    steps: [
      "Antes de mover, mira la pieza rival mas cercana a una ruta clave.",
      "Calcula si tu bloque quedara dominado o protegido.",
      "Revisa si abres una captura o un rescate para el siguiente turno.",
      "En Azar, considera que la tirada puede limitar la respuesta.",
      "Confirma solo si entiendes el riesgo principal.",
    ],
    examples: [
      "Mover un bloque a una columna alta puede bloquear una ruta rival, pero tambien dejar otro flanco abierto.",
      "Anticipar ayuda a no mover el especial hacia una casilla vulnerable.",
    ],
    faqs: [
      faq("Anticipacion es adivinar?", "No. Es leer posibilidades con informacion visible."),
      faq("Se puede practicar?", "Si, pausando replays antes de cada turno y prediciendo la jugada siguiente."),
    ],
    links: [
      link("Planificacion", "diccionario/planificacion"),
      link("Riesgo", "diccionario/riesgo"),
      link("Replay", "historial-y-replay"),
    ],
    cta: { label: "Ver riesgo", path: "diccionario/riesgo" },
    sources: ["F08", "F41", "F33"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/riesgo",
    category: "diccionario",
    title: "Riesgo en XIMA | Diccionario de decisiones",
    metaDescription:
      "Aprende que significa riesgo en XIMA, especialmente al mover con dados, rutas abiertas y bloque especial.",
    h1: "Riesgo",
    intro:
      "Riesgo es la posibilidad de que una jugada legal deje una debilidad en la posicion.",
    verified:
      "Modo Azar introduce dados y todos los modos mantienen consecuencias de tablero como bloqueo, captura y rescate.",
    usage:
      "Evalua riesgo antes de mover el especial, subir una columna o dejar un bloque sin apoyo.",
    caution:
      "La guia no ofrece probabilidades exactas ni promesas de resultado.",
    steps: [
      "Identifica que pierdes si la jugada sale mal.",
      "Revisa si el bloque especial queda mas expuesto.",
      "Compara rutas alternativas con menor exposicion.",
      "En Azar, lee los dados antes de decidir.",
      "Despues de jugar, confirma en replay si el riesgo era visible.",
    ],
    examples: [
      "Avanzar hacia la cima puede ser arriesgado si una columna rival queda por encima.",
      "No mover tambien puede ser riesgoso si todos los bloques quedan dominados.",
    ],
    faqs: [
      faq("Riesgo significa mala jugada?", "No. Un riesgo puede ser aceptable si el beneficio esta claro."),
      faq("Donde se ve mejor el riesgo?", "En replay, pausando antes y despues de la jugada clave."),
    ],
    links: [
      link("Probabilidad", "diccionario/probabilidad"),
      link("Azar", "azar"),
      link("Aprender de una derrota", "articulos/aprender-de-una-derrota"),
    ],
    cta: { label: "Ver probabilidad", path: "diccionario/probabilidad" },
    sources: ["F08", "F42", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/probabilidad",
    category: "diccionario",
    title: "Probabilidad en juegos de estrategia | XIMA",
    metaDescription:
      "Definicion prudente de probabilidad aplicada a Modo Azar de XIMA y lectura de decisiones con dados.",
    h1: "Probabilidad",
    intro:
      "Probabilidad ayuda a pensar en resultados posibles, pero XIMA no publica una formula estrategica oficial.",
    verified:
      "Los dados de Unity generan valores entre 1 y 6 y Modo Azar usa dados en la decision de movimiento.",
    usage:
      "Usa probabilidad como lenguaje de riesgo: que opciones abre una tirada y que opciones no conviene forzar.",
    caution:
      "No se presentan calculos como garantia de victoria ni estadisticas no verificadas.",
    steps: [
      "Identifica si la partida usa dados.",
      "Lee la tirada actual y sus rutas legales.",
      "Separa jugadas posibles de jugadas deseables.",
      "Considera el estado del bloque especial antes de avanzar.",
      "Revisa el resultado posterior en historial o replay.",
    ],
    examples: [
      "Una tirada que permite muchos destinos no significa que todos sean buenos.",
      "Una tirada baja puede reducir opciones, pero tambien evitar exposicion innecesaria.",
    ],
    faqs: [
      faq("XIMA muestra calculadora de probabilidad?", "No esta documentada como funcion publica en esta guia."),
      faq("Probabilidad aplica a Ciencia?", "En Ciencia no se usan dados visibles, pero sigue existiendo incertidumbre por respuestas del rival."),
    ],
    links: [
      link("Modo Azar", "azar"),
      link("Probabilidad y decisiones", "azar/probabilidad-decisiones"),
      link("Toma de decisiones", "diccionario/toma-de-decisiones"),
    ],
    cta: { label: "Ver decisiones", path: "diccionario/toma-de-decisiones" },
    sources: ["F08", "F42"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/toma-de-decisiones",
    category: "diccionario",
    title: "Toma de decisiones en XIMA | Diccionario",
    metaDescription:
      "Como entender la toma de decisiones en XIMA usando reglas, modos, replay y lectura del tablero.",
    h1: "Toma de decisiones",
    intro:
      "Tomar decisiones en XIMA es elegir una accion legal con informacion visible del tablero y del modo.",
    verified:
      "El turno permite incorporar o mover, y el modo puede sumar dados o decision libre segun la partida.",
    usage:
      "Usa una secuencia simple: objetivo, opciones legales, riesgo, consecuencia y revision posterior.",
    caution:
      "No existe una jugada unica recomendada para todas las posiciones.",
    steps: [
      "Define si necesitas avanzar, defender, capturar o rescatar.",
      "Enumera las acciones legales disponibles.",
      "Descarta las que rompen reglas de movimiento.",
      "Compara riesgo y beneficio de las opciones restantes.",
      "Despues de jugar, revisa la decision en replay cuando sea posible.",
    ],
    examples: [
      "Elegir incorporar puede ser correcto si aun no tienes presencia suficiente.",
      "Mover el especial puede ser incorrecto si queda bajo amenaza inmediata.",
    ],
    faqs: [
      faq("Como se mejora la toma de decisiones?", "Revisando reglas y replays con una pregunta concreta por partida."),
      faq("Los dados deciden por mi?", "No. En Azar condicionan opciones, pero el jugador sigue eligiendo una jugada."),
    ],
    links: [
      link("Como mejorar decisiones", "articulos/como-mejorar-la-toma-de-decisiones"),
      link("Riesgo", "diccionario/riesgo"),
      link("Jugada legal", "reglas/jugada-legal"),
    ],
    cta: { label: "Ver jugada legal", path: "reglas/jugada-legal" },
    sources: ["F08", "F41", "F42"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/pensamiento-logico",
    category: "diccionario",
    title: "Pensamiento logico y XIMA | Diccionario",
    metaDescription:
      "Relacion entre pensamiento logico y XIMA explicada con reglas verificadas, sin afirmaciones educativas no aprobadas.",
    h1: "Pensamiento logico",
    intro:
      "Pensamiento logico significa seguir consecuencias visibles: si una regla aplica, una jugada es posible o no.",
    verified:
      "Las reglas de XIMA sobre linea recta, tablero, altura y bloques especiales permiten razonar paso a paso.",
    usage:
      "Usa pensamiento logico para comprobar una jugada antes de atribuir un rechazo a un error de la plataforma.",
    caution:
      "No se hacen promesas medicas, escolares ni de mejora cognitiva.",
    steps: [
      "Lee la regla que afecta la jugada.",
      "Observa si la posicion cumple las condiciones de esa regla.",
      "Comprueba origen, ruta y destino.",
      "Determina si el resultado esperado coincide con la interfaz.",
      "Registra dudas para soporte solo si hay discrepancia verificable.",
    ],
    examples: [
      "Si el bloque ya entro al tablero, no puede moverse fuera de el.",
      "Si el movimiento cambia de direccion, no cumple la regla de linea recta.",
    ],
    faqs: [
      faq("Pensamiento logico es una funcion del juego?", "No. Es una forma de estudiar las reglas y decisiones."),
      faq("Puede usarse en cualquier modo?", "Si. Las reglas base se razonan en todos los modos."),
    ],
    links: [
      link("Reglas", "reglas"),
      link("Movimiento", "diccionario/movimiento"),
      link("Juegos de estrategia y pensamiento logico", "articulos/juegos-estrategia-pensamiento-logico"),
    ],
    cta: { label: "Ver reglas", path: "reglas" },
    sources: ["F08", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/ataque",
    category: "diccionario",
    title: "Ataque en XIMA | Diccionario de estrategia",
    metaDescription:
      "Define ataque en XIMA como presion hacia la cima, captura o restriccion de rutas, con ejemplos seguros.",
    h1: "Ataque",
    intro:
      "Ataque es presionar una zona importante del tablero o acercarse a una condicion favorable.",
    verified:
      "El objetivo de la cima y las reglas de dominacion permiten hablar de presion y captura de forma publica.",
    usage:
      "Ataca cuando una jugada legal mejora tu ruta o limita la respuesta del rival sin dejar desprotegido el especial.",
    caution:
      "No se nombran combinaciones oficiales de ataque hasta tener ejemplos aprobados.",
    steps: [
      "Ubica la cima y las columnas que conectan con ella.",
      "Revisa que bloque puede avanzar o bloquear con seguridad.",
      "Comprueba si una captura o dominacion cambia la columna.",
      "Evita atacar si tu especial queda expuesto sin apoyo.",
      "Confirma la jugada y revisa su efecto en el siguiente turno.",
    ],
    examples: [
      "Subir un bloque comun puede presionar una ruta hacia la cima.",
      "Atacar una columna puede obligar al rival a defender en vez de avanzar.",
    ],
    faqs: [
      faq("Ataque siempre significa capturar?", "No. Tambien puede ser presion de ruta o control de una zona."),
      faq("Como se estudia un ataque?", "Pausando el replay antes de la jugada y mirando que cambio produjo."),
    ],
    links: [
      link("Defensa", "diccionario/defensa"),
      link("Ventaja", "diccionario/ventaja"),
      link("Subir bloques", "reglas/subir-bloques"),
    ],
    cta: { label: "Ver defensa", path: "diccionario/defensa" },
    sources: ["F08", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/defensa",
    category: "diccionario",
    title: "Defensa en XIMA | Diccionario",
    metaDescription:
      "Aprende que significa defensa en XIMA: proteger el bloque especial, evitar capturas y sostener rutas.",
    h1: "Defensa",
    intro:
      "Defender es reducir amenazas sobre tu posicion, especialmente sobre el bloque especial y las rutas hacia la cima.",
    verified:
      "El bloque especial, la captura, el rescate y la dominacion son conceptos documentados en reglas y conocimiento interno.",
    usage:
      "Defiende cuando el rival amenaza una columna clave o cuando tu especial podria quedar capturado.",
    caution:
      "No toda jugada pasiva es defensa; debe responder a una amenaza visible.",
    steps: [
      "Localiza amenazas contra el bloque especial.",
      "Busca si un bloque comun puede cubrir, liberar o bloquear una columna.",
      "Comprueba que el movimiento defensivo sea legal.",
      "Evita cerrar tu propia ruta de rescate.",
      "Revisa en replay si la amenaza quedo neutralizada.",
    ],
    examples: [
      "Mover un comun para impedir una subida rival puede ser defensa.",
      "Rescatar el especial capturado es una forma especifica de defensa activa.",
    ],
    faqs: [
      faq("Defensa significa no avanzar?", "No. Puede incluir movimientos que preparan rescate o control futuro."),
      faq("Que pieza se protege primero?", "El bloque especial suele ser central porque esta ligado a la victoria."),
    ],
    links: [
      link("Bloque especial", "reglas/bloque-especial"),
      link("Rescate", "reglas/rescate"),
      link("Ataque", "diccionario/ataque"),
    ],
    cta: { label: "Ver rescate", path: "reglas/rescate" },
    sources: ["F08", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/ventaja",
    category: "diccionario",
    title: "Ventaja en XIMA | Diccionario de posicion",
    metaDescription:
      "Que significa ventaja en XIMA y como leerla con tablero, bloque especial, ruta a la cima y replay.",
    h1: "Ventaja",
    intro:
      "Ventaja es una posicion que ofrece mejores opciones visibles que la del rival, sin asegurar victoria.",
    verified:
      "XIMA permite evaluar ventaja por rutas, altura, bloque especial, capturas y estado de columnas.",
    usage:
      "Mide ventaja revisando si tienes mas opciones legales, mejor acceso a la cima o menos amenazas sobre el especial.",
    caution:
      "No se publican valores numericos universales de ventaja.",
    steps: [
      "Compara acceso de ambos jugadores a la cima.",
      "Observa que bloques estan libres, dominados o capturados.",
      "Revisa si tu especial esta seguro.",
      "Cuenta opciones legales utiles, no solo cantidad de movimientos.",
      "Verifica en replay si la ventaja se convirtio en resultado.",
    ],
    examples: [
      "Tener una ruta abierta hacia la cima puede ser ventaja si el rival no puede bloquearla.",
      "Tener mas bloques no basta si todos quedan dominados.",
    ],
    faqs: [
      faq("Ventaja es lo mismo que ganar?", "No. Una ventaja puede perderse con una mala decision."),
      faq("CIMAX mide ventaja?", "CIMAX es una metrica del producto; no debe confundirse con evaluacion absoluta de posicion."),
    ],
    links: [
      link("Posicion", "diccionario/posicion"),
      link("CIMAX", "glosario/cimax"),
      link("Replay", "historial-y-replay"),
    ],
    cta: { label: "Ver posicion", path: "diccionario/posicion" },
    sources: ["F08", "F41", "F47"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/posicion",
    category: "diccionario",
    title: "Posicion en XIMA | Tablero, bloques y estado",
    metaDescription:
      "Define posicion en XIMA como el estado del tablero, los bloques, alturas, rutas y turno actual.",
    h1: "Posicion",
    intro:
      "La posicion es la fotografia jugable del tablero: donde estan los bloques y que opciones existen.",
    verified:
      "El tablero, casillas, coordenadas, bloques y replay permiten describir una posicion sin datos privados.",
    usage:
      "Antes de decidir, lee la posicion completa: piezas, altura, cima, turno y modo.",
    caution:
      "Una posicion no debe publicarse con nombres de usuarios reales sin permiso.",
    steps: [
      "Ubica la cima y el nivel de cada zona relevante.",
      "Identifica tus bloques comunes y tu bloque especial.",
      "Mira piezas rivales que pueden dominar o bloquear.",
      "Relaciona la posicion con el modo activo.",
      "Usa anotacion o replay para guardar el contexto si existe.",
    ],
    examples: [
      "Una posicion con el especial cerca de la cima exige revisar amenazas antes de avanzar.",
      "Una columna alta puede ser oportunidad o peligro segun quien la controla.",
    ],
    faqs: [
      faq("Posicion y movimiento son lo mismo?", "No. Posicion es el estado; movimiento es la accion que lo cambia."),
      faq("Como describo una posicion?", "Usa tablero, coordenadas y piezas visibles sin datos privados."),
    ],
    links: [
      link("Movimiento", "diccionario/movimiento"),
      link("Coordenadas", "reglas/coordenadas"),
      link("Tablero", "reglas/tablero-y-casillas"),
    ],
    cta: { label: "Ver coordenadas", path: "reglas/coordenadas" },
    sources: ["F08", "F41", "F33"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/movimiento",
    category: "diccionario",
    title: "Movimiento en XIMA | Diccionario",
    metaDescription:
      "Que significa movimiento en XIMA: desplazar un bloque ya colocado respetando linea, tablero y altura.",
    h1: "Movimiento",
    intro:
      "Movimiento es desplazar un bloque propio que ya esta en juego, distinto de incorporar uno nuevo.",
    verified:
      "Las reglas publicas separan incorporar un bloque y mover un bloque que ya esta en el tablero.",
    usage:
      "Usa movimiento cuando la pieza ya esta dentro y puede avanzar en linea recta a un destino legal.",
    caution:
      "No confundas movimiento con salida del tablero: una vez dentro, el bloque no puede moverse fuera.",
    steps: [
      "Selecciona un bloque propio que ya este en el tablero.",
      "Elige una direccion recta: vertical, horizontal o diagonal.",
      "Comprueba cantidad de pasos y altura permitida.",
      "Verifica que el destino siga dentro del tablero.",
      "Confirma solo si el modo no impone una restriccion adicional como dados.",
    ],
    examples: [
      "Mover un bloque comun puede abrir una ruta o bloquear una columna.",
      "En Azar, la cantidad de pasos puede depender de la tirada.",
    ],
    faqs: [
      faq("Mover e incorporar son iguales?", "No. Incorporar trae un bloque desde fuera; mover desplaza uno ya colocado."),
      faq("El bloque puede salir del tablero?", "No despues de entrar a jugar."),
    ],
    links: [
      link("Sistema de movimientos", "reglas/movimientos"),
      link("Incorporar un bloque", "reglas/incorporar-bloque"),
      link("Jugada legal", "reglas/jugada-legal"),
    ],
    cta: { label: "Ver movimientos", path: "reglas/movimientos" },
    sources: ["F08", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/objetivo",
    category: "diccionario",
    title: "Objetivo en XIMA | Diccionario",
    metaDescription:
      "Define el objetivo de XIMA y como se relaciona con bloque especial, cima, victoria y rescate.",
    h1: "Objetivo",
    intro:
      "El objetivo principal de XIMA es llevar el bloque especial propio a la cima del tablero.",
    verified:
      "La documentacion y las reglas publicas sostienen la cima como condicion central de victoria del bloque especial.",
    usage:
      "Usa el objetivo como filtro de decisiones: cada movimiento deberia acercarte a ganar o evitar perder.",
    caution:
      "No todas las reglas especiales de empate o incremento de material estan listas para explicacion avanzada.",
    steps: [
      "Identifica tu bloque especial.",
      "Ubica la cima del tablero.",
      "Evalua si puedes acercarte sin romper reglas de movimiento.",
      "Protege o rescata el especial si la posicion lo exige.",
      "Usa replay para revisar si tus turnos ayudaron al objetivo.",
    ],
    examples: [
      "Llegar a la cima con el especial puede cerrar la partida.",
      "Un comun puede llegar a la cima para rescatar al especial capturado en el caso documentado.",
    ],
    faqs: [
      faq("Cual es el objetivo central?", "Llevar el bloque especial a la cima."),
      faq("Un bloque comun gana al llegar a la cima?", "Solo se documenta su llegada en contexto de rescate del especial capturado."),
    ],
    links: [
      link("Objetivo del juego", "reglas/objetivo"),
      link("Cima", "reglas/cima"),
      link("Bloque especial", "reglas/bloque-especial"),
    ],
    cta: { label: "Ver objetivo del juego", path: "reglas/objetivo" },
    sources: ["F08", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/error",
    category: "diccionario",
    title: "Error en XIMA | Aprender de una jugada",
    metaDescription:
      "Que significa error en XIMA y como revisarlo con reglas, replay, soporte y aprendizaje responsable.",
    h1: "Error",
    intro:
      "Un error puede ser una decision mala, una jugada no permitida o una interpretacion equivocada de la interfaz.",
    verified:
      "El proyecto incluye reglas, validaciones de movimiento, historial, replay y soporte para revisar problemas.",
    usage:
      "Distingue error de regla, error de decision y posible incidencia tecnica antes de reportar.",
    caution:
      "No compartas datos privados, contrasenas ni capturas sensibles al pedir ayuda publica.",
    steps: [
      "Reproduce mentalmente que intentaste hacer.",
      "Compara la accion con reglas de movimiento y modo.",
      "Abre replay o historial si la partida quedo registrada.",
      "Si parece incidencia, describe solo el problema visible.",
      "Usa soporte sin incluir datos sensibles.",
    ],
    examples: [
      "Un movimiento rechazado por altura no es un bug si rompe la regla.",
      "Un replay ausente puede ser un estado documentado si la partida no lo guardo.",
    ],
    faqs: [
      faq("Todo error debe ir a soporte?", "No. Primero revisa reglas y guias relacionadas."),
      faq("Que datos no debo publicar?", "No publiques contrasenas, claves, tokens ni datos personales."),
    ],
    links: [
      link("Aprender de una derrota", "articulos/aprender-de-una-derrota"),
      link("Movimiento no permitido", "solucion/movimiento-no-permitido"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Ver soporte", path: "soporte" },
    sources: ["F08", "F33", "F36"],
    structuredDataType: "Article",
  },
  {
    slug: "diccionario/analisis",
    category: "diccionario",
    title: "Analisis en XIMA | Diccionario de replay",
    metaDescription:
      "Define analisis en XIMA como revision de posiciones, turnos, anotacion, replay y decisiones.",
    h1: "Analisis",
    intro:
      "Analisis es revisar una partida o posicion para entender que decision cambio el resultado o la ruta.",
    verified:
      "La plataforma ofrece historial, replay, controles, timeline y sistema de anotacion para estudiar partidas.",
    usage:
      "Analiza una pregunta concreta: por que una ruta funciono, donde aparecio una captura o que turno cambio la partida.",
    caution:
      "Evita publicar analisis con datos personales de jugadores sin consentimiento.",
    steps: [
      "Elige una partida o posicion con informacion suficiente.",
      "Define la pregunta de analisis antes de reproducir.",
      "Pausa en el turno donde aparece el cambio.",
      "Compara posicion, reglas y anotacion.",
      "Escribe una conclusion breve y verificable.",
    ],
    examples: [
      "Analizar una captura requiere mirar la columna antes y despues del movimiento.",
      "Analizar una derrota puede centrarse en el primer turno donde el especial quedo expuesto.",
    ],
    faqs: [
      faq("Analisis y replay son lo mismo?", "No. Replay es la herramienta; analisis es el uso que haces de ella."),
      faq("Puedo analizar partidas de otros?", "Solo con informacion publica o autorizada."),
    ],
    links: [
      link("Analisis de partidas", "academia/analisis-partidas"),
      link("Replay", "historial-y-replay"),
      link("Leer anotacion", "replay/leer-anotacion"),
    ],
    cta: { label: "Ver analisis de partidas", path: "academia/analisis-partidas" },
    sources: ["F08", "F18", "F33"],
    structuredDataType: "Article",
  },
  {
    slug: "articulos/como-mejorar-la-toma-de-decisiones",
    category: "articulos",
    title: "Como mejorar la toma de decisiones en XIMA",
    metaDescription:
      "Guia practica para mejorar decisiones en XIMA revisando objetivo, reglas, riesgo, replay y estadisticas visibles.",
    h1: "Como mejorar la toma de decisiones",
    intro:
      "Mejorar decisiones en XIMA empieza por separar lo que quieres lograr de lo que las reglas permiten hacer.",
    verified:
      "Las reglas, modos, replay y estadisticas visibles permiten revisar decisiones sin inventar beneficios externos.",
    usage:
      "Aplica un ciclo corto: observar, elegir, jugar, revisar y ajustar.",
    caution:
      "Esta guia no promete victorias ni mejoras medibles fuera de la practica dentro del juego.",
    steps: [
      "Antes del turno, define si buscas avanzar, defender o rescatar.",
      "Descarta jugadas ilegales segun movimiento y altura.",
      "Evalua el riesgo sobre tu bloque especial.",
      "Despues de jugar, revisa un turno clave en replay.",
      "Compara el resultado con tu plan inicial.",
    ],
    examples: [
      "Si pierdes por exponer el especial, la mejora puede ser revisar defensa antes de atacar.",
      "Si fallas en Azar, revisa si ignoraste la tirada o si elegiste mal entre rutas legales.",
    ],
    faqs: [
      faq("Hay una tecnica unica para decidir?", "No. La decision depende de posicion, modo y objetivo."),
      faq("Debo mirar estadisticas siempre?", "Son utiles, pero el replay suele explicar mejor una decision concreta."),
    ],
    links: [
      link("Toma de decisiones", "diccionario/toma-de-decisiones"),
      link("Riesgo", "diccionario/riesgo"),
      link("Replay", "historial-y-replay"),
    ],
    cta: { label: "Ver toma de decisiones", path: "diccionario/toma-de-decisiones" },
    sources: ["F08", "F18", "F19", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "articulos/tactica-vs-estrategia",
    category: "articulos",
    title: "Tactica vs estrategia en XIMA | Diferencias con ejemplos",
    metaDescription:
      "Aprende la diferencia entre tactica y estrategia usando ejemplos verificados de XIMA, tablero y replay.",
    h1: "Tactica vs estrategia",
    intro:
      "Estrategia y tactica se complementan: una organiza el plan, la otra resuelve un momento concreto.",
    verified:
      "XIMA ofrece reglas de movimiento, objetivo de cima, captura y replay para explicar ambas ideas con base real.",
    usage:
      "Usa estrategia para elegir rumbo general y tactica para responder a una amenaza o oportunidad inmediata.",
    caution:
      "Los ejemplos no describen teoria oficial avanzada, solo lectura publica de reglas.",
    steps: [
      "Define el objetivo de largo plazo de la posicion.",
      "Detecta la amenaza o oportunidad del turno actual.",
      "Elige una accion tactica que no contradiga el plan.",
      "Revisa si la jugada mejora tu ruta o defensa.",
      "Comprueba en replay si el plan siguio vivo despues del turno.",
    ],
    examples: [
      "Estrategia: acercar el especial a una ruta segura. Tactica: bloquear una columna que lo amenaza.",
      "Estrategia: jugar por control de altura. Tactica: rescatar un especial capturado.",
    ],
    faqs: [
      faq("Cual aprendo primero?", "Primero reglas y objetivo; luego tactica y estrategia."),
      faq("Azar cambia la diferencia?", "No. Agrega dados, pero plan y solucion concreta siguen siendo utiles."),
    ],
    links: [
      link("Estrategia", "diccionario/estrategia"),
      link("Tactica", "diccionario/tactica"),
      link("Planificacion", "diccionario/planificacion"),
    ],
    cta: { label: "Ver estrategia", path: "diccionario/estrategia" },
    sources: ["F08", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "articulos/aprender-de-una-derrota",
    category: "articulos",
    title: "Como aprender de una derrota en XIMA",
    metaDescription:
      "Usa historial, replay, anotacion y reglas para convertir una derrota en informacion util dentro de XIMA.",
    h1: "Aprender de una derrota",
    intro:
      "Una derrota en XIMA puede revisarse como una secuencia de decisiones, no como un dato aislado.",
    verified:
      "Historial y replay permiten revisar partidas finalizadas cuando existe registro disponible.",
    usage:
      "Busca una causa concreta: ruta cerrada, bloque especial expuesto, captura o decision de dados.",
    caution:
      "No uses partidas de otros jugadores para senalar personas ni publicar datos privados.",
    steps: [
      "Abre Historial y busca la partida perdida.",
      "Reproduce la partida hasta el primer momento de desventaja clara.",
      "Pausa y revisa que regla o decision estuvo involucrada.",
      "Compara con una alternativa legal que habrias podido jugar.",
      "Guarda una leccion breve para la proxima partida.",
    ],
    examples: [
      "Si perdiste por la cima, revisa dos turnos antes de la llegada final.",
      "Si el especial fue capturado, revisa donde falto defensa o rescate.",
    ],
    faqs: [
      faq("Debo revisar toda la partida?", "No siempre. Empieza por el primer punto de cambio visible."),
      faq("Las estadisticas explican la derrota?", "Pueden dar contexto, pero el replay muestra decisiones concretas."),
    ],
    links: [
      link("Historial", "historial"),
      link("Ver replay", "tutoriales/ver-replay"),
      link("Error", "diccionario/error"),
    ],
    cta: { label: "Ver replay", path: "tutoriales/ver-replay" },
    sources: ["F08", "F18", "F33"],
    structuredDataType: "Article",
  },
  {
    slug: "articulos/planificar-varios-movimientos",
    category: "articulos",
    title: "Como planificar varios movimientos en XIMA",
    metaDescription:
      "Aprende a planificar varios movimientos en XIMA usando objetivo, tablero, altura, modos y replay.",
    h1: "Planificar varios movimientos",
    intro:
      "Planificar varios movimientos no significa adivinar el futuro, sino preparar opciones legales.",
    verified:
      "XIMA es por turnos y sus reglas de movimiento permiten evaluar rutas y consecuencias antes de confirmar.",
    usage:
      "Elige planes flexibles: una ruta principal, una defensa y una respuesta si la posicion cambia.",
    caution:
      "En Azar, los dados pueden cambiar el plan; en Ciencia, el rival tambien puede cerrar rutas.",
    steps: [
      "Mira la posicion actual y define una meta cercana.",
      "Elige un movimiento legal que mejore esa meta.",
      "Imagina una respuesta rival que bloquee tu ruta.",
      "Prepara una alternativa con otro bloque comun.",
      "Despues de varios turnos, revisa en replay si mantuviste opciones.",
    ],
    examples: [
      "Una ruta hacia la cima puede necesitar un bloque comun antes de mover el especial.",
      "Una defensa puede formar parte del plan si evita captura futura.",
    ],
    faqs: [
      faq("Cuantos movimientos debo planificar?", "Los suficientes para entender el riesgo inmediato; no hace falta una linea larga."),
      faq("Sirve en modo Azar?", "Si, pero con margen por dados."),
    ],
    links: [
      link("Planificacion", "diccionario/planificacion"),
      link("Anticipacion", "diccionario/anticipacion"),
      link("Modo Ciencia", "ciencia"),
    ],
    cta: { label: "Ver planificacion", path: "diccionario/planificacion" },
    sources: ["F08", "F41", "F42"],
    structuredDataType: "Article",
  },
  {
    slug: "articulos/errores-comunes-juegos-estrategia",
    category: "articulos",
    title: "Errores comunes en juegos de estrategia | Ejemplos con XIMA",
    metaDescription:
      "Errores comunes al aprender juegos de estrategia explicados con reglas verificadas de XIMA.",
    h1: "Errores comunes en juegos de estrategia",
    intro:
      "XIMA permite observar errores frecuentes porque cada jugada queda limitada por reglas visibles.",
    verified:
      "Las reglas de XIMA cubren objetivo, turnos, tablero, movimiento, captura, rescate y estancamiento.",
    usage:
      "Usa los errores como lista de revision antes de mover o al analizar una partida.",
    caution:
      "La guia habla del aprendizaje dentro del juego, no de evaluaciones personales de jugadores.",
    steps: [
      "Comprueba si estas persiguiendo el objetivo o solo moviendo por mover.",
      "Revisa si confundiste incorporar con mover.",
      "No avances el especial sin mirar amenazas.",
      "En Azar, no ignores la tirada visible.",
      "Despues de perder, revisa una causa concreta en replay.",
    ],
    examples: [
      "Mover fuera de linea recta es un error de regla.",
      "Atacar sin defensa puede convertir una ventaja aparente en riesgo.",
    ],
    faqs: [
      faq("Esta guia aplica solo a XIMA?", "Usa XIMA como ejemplo verificado, aunque algunos principios son generales."),
      faq("Como corrijo errores?", "Con reglas, practica y revision de replay."),
    ],
    links: [
      link("Error", "diccionario/error"),
      link("Jugada legal", "reglas/jugada-legal"),
      link("Aprender de una derrota", "articulos/aprender-de-una-derrota"),
    ],
    cta: { label: "Ver jugada legal", path: "reglas/jugada-legal" },
    sources: ["F08", "F41", "F33"],
    structuredDataType: "Article",
  },
  {
    slug: "articulos/juegos-estrategia-pensamiento-logico",
    category: "articulos",
    title: "Juegos de estrategia y pensamiento logico | XIMA",
    metaDescription:
      "Explicacion responsable de pensamiento logico en juegos de estrategia usando reglas y ejemplos de XIMA.",
    h1: "Juegos de estrategia y pensamiento logico",
    intro:
      "XIMA se puede usar para practicar lectura de reglas, consecuencias y decisiones, sin hacer promesas educativas externas.",
    verified:
      "El proyecto documenta reglas concretas que obligan a revisar condiciones antes de mover.",
    usage:
      "Piensa en cada turno como una cadena: regla aplicable, opcion legal, consecuencia visible y revision.",
    caution:
      "No se afirma beneficio escolar, medico ni cognitivo no demostrado por documentos oficiales.",
    steps: [
      "Elige una regla concreta de XIMA.",
      "Busca una posicion donde esa regla importe.",
      "Predice si una jugada sera legal o no.",
      "Comprueba el resultado en la interfaz o replay.",
      "Ajusta tu lectura si la regla se aplico distinto a lo esperado.",
    ],
    examples: [
      "La regla de no salir del tablero despues de entrar es un caso logico claro.",
      "La regla de altura permite comprobar si una subida es legal antes de intentar mover.",
    ],
    faqs: [
      faq("XIMA promete mejorar pensamiento logico?", "No se publica esa promesa; la guia solo explica como razonar reglas."),
      faq("Que tema conviene estudiar?", "Movimiento y objetivo son los mejores puntos de entrada."),
    ],
    links: [
      link("Pensamiento logico", "diccionario/pensamiento-logico"),
      link("Reglas", "reglas"),
      link("Movimientos", "reglas/movimientos"),
    ],
    cta: { label: "Ver pensamiento logico", path: "diccionario/pensamiento-logico" },
    sources: ["F08", "F41"],
    structuredDataType: "Article",
  },
  {
    slug: "articulos/inteligencia-artificial-juegos-de-mesa",
    category: "articulos",
    title: "Inteligencia artificial en juegos de mesa | Caso XIMA",
    metaDescription:
      "Explicacion prudente de IA en XIMA: bots, practica y limites publicos sin revelar detalles sensibles.",
    h1: "Inteligencia artificial en juegos de mesa",
    intro:
      "XIMA incluye bots y rutas de IA para practica, pero la documentacion publica debe evitar promesas tecnicas no verificadas.",
    verified:
      "El repositorio contiene pantalla de bots, backend scienceBot y selector de movimientos de ScienceBot en Unity.",
    usage:
      "Presenta la IA como herramienta de practica y simulacion dentro del juego, no como evaluador absoluto de jugador.",
    caution:
      "No se exponen algoritmos internos, endpoints sensibles ni metricas de fuerza no publicadas.",
    steps: [
      "Abre la guia de bots para conocer el flujo visible.",
      "Selecciona un modo o dificultad disponible en la interfaz.",
      "Juega una partida de practica completa.",
      "Revisa decisiones con replay o estadisticas si quedan disponibles.",
      "No atribuyas al bot capacidades que el proyecto no documenta.",
    ],
    examples: [
      "Un bot puede servir para repetir patrones de movimiento cuando no hay rival humano.",
      "Una dificultad visible no debe traducirse en una promesa tecnica de fuerza exacta.",
    ],
    faqs: [
      faq("La IA de XIMA esta documentada completa?", "No para fines publicos; se explica solo lo visible y verificable."),
      faq("Puedo jugar con bot?", "Si. El frontend contiene una pantalla de Jugar con bot."),
    ],
    links: [
      link("Bots", "bots"),
      link("Entrenar IA en Ciencia", "ciencia/entrenar-ia"),
      link("Dificultad de bot", "bots/dificultad"),
    ],
    cta: { label: "Ver bots", path: "bots" },
    sources: ["F13", "F38"],
    structuredDataType: "Article",
    status: "partial",
  },
  {
    slug: "articulos/ciencia-y-azar-en-juegos",
    category: "articulos",
    title: "Ciencia y azar en juegos | XIMA",
    metaDescription:
      "Compara decisiones libres y dados en XIMA con Modo Ciencia, Modo Azar y paginas pendientes de Cienzar.",
    h1: "Ciencia y azar en juegos",
    intro:
      "XIMA separa modos donde la decision no depende de dados visibles y modos donde los dados influyen en el movimiento.",
    verified:
      "Modo Ciencia se documenta como free; Modo Azar se documenta como dice; Cienzar queda pendiente de confirmacion fina.",
    usage:
      "Usa esta comparacion para elegir que quieres practicar: lectura pura de posicion o decision con dados.",
    caution:
      "No se publica una jerarquia de cual modo es mejor, mas estrategico o mas educativo.",
    steps: [
      "Lee primero Modo Ciencia y Modo Azar por separado.",
      "Identifica si quieres practicar sin dados o con tirada visible.",
      "Revisa reglas generales porque ambos comparten tablero y objetivo.",
      "Consulta Cienzar solo como tema pendiente si necesitas modo hibrido.",
      "Elige una partida y revisa la experiencia con replay.",
    ],
    examples: [
      "Ciencia permite concentrarse en rutas sin dados visibles.",
      "Azar obliga a adaptar la decision a resultados de dados.",
    ],
    faqs: [
      faq("Ciencia significa que no hay estrategia en Azar?", "No. Azar tambien requiere decisiones."),
      faq("Cienzar esta confirmado completo?", "No. Sus detalles avanzados estan marcados como pendientes."),
    ],
    links: [
      link("Modo Ciencia", "ciencia"),
      link("Modo Azar", "azar"),
      link("Cienzar", "cienzar"),
    ],
    cta: { label: "Ver modos de juego", path: "modos-de-juego" },
    sources: ["F08", "F10", "F11", "F42"],
    structuredDataType: "Article",
  },
  {
    slug: "articulos/analizar-partida-paso-a-paso",
    category: "articulos",
    title: "Como analizar una partida de XIMA paso a paso",
    metaDescription:
      "Metodo paso a paso para analizar una partida de XIMA con replay, timeline, anotacion, reglas y ejemplos seguros.",
    h1: "Analizar una partida paso a paso",
    intro:
      "Un buen analisis no intenta explicar todo: elige un momento, una regla y una conclusion.",
    verified:
      "Replay, timeline, controles, anotacion e historial son funciones documentadas del proyecto.",
    usage:
      "Sigue una secuencia fija para evitar conclusiones vagas: contexto, turno, regla, decision y aprendizaje.",
    caution:
      "No publiques identidades, datos privados ni partidas no autorizadas.",
    steps: [
      "Selecciona una partida con replay disponible.",
      "Anota modo, jugadores visibles y resultado solo si es publico o propio.",
      "Avanza hasta una jugada que cambie la posicion.",
      "Compara esa jugada con reglas de movimiento, captura o rescate.",
      "Escribe una conclusion accionable para practicar despues.",
    ],
    examples: [
      "Una jugada clave puede ser la primera captura del bloque especial.",
      "Otra jugada clave puede ser el turno donde una ruta a la cima quedo abierta.",
    ],
    faqs: [
      faq("Que hago si el replay no reproduce?", "Consulta la guia de solucion de replay."),
      faq("Puedo analizar sin saber toda la teoria?", "Si. Empieza por reglas basicas y una sola pregunta."),
    ],
    links: [
      link("Replay no reproduce", "solucion/replay-no-reproduce"),
      link("Leer anotacion", "replay/leer-anotacion"),
      link("Analisis", "diccionario/analisis"),
    ],
    cta: { label: "Ver leer anotacion", path: "replay/leer-anotacion" },
    sources: ["F08", "F18", "F33"],
  },
  {
    slug: "solucion/unity-no-carga",
    category: "solucion",
    title: "Unity no carga en XIMA | Solucion de problemas",
    metaDescription:
      "Pasos seguros si el tablero Unity de XIMA no carga: navegador, WebGL, conexion, recarga y soporte.",
    h1: "Unity no carga",
    intro:
      "El tablero de XIMA usa una build de Unity WebGL; si no carga, conviene revisar compatibilidad y estado visible.",
    verified:
      "El frontend sincroniza la build Unity y el proyecto incluye archivos Build, TemplateData e index de Unity.",
    usage:
      "Revisa causas simples antes de reportar: navegador compatible, recursos cargados, sesion y conexion.",
    caution:
      "No compartas consola con tokens, datos de sesion ni informacion personal.",
    steps: [
      "Recarga la pagina de la partida una sola vez.",
      "Comprueba que tu navegador tenga WebGL habilitado.",
      "Cierra otras pestanas pesadas si el dispositivo tiene poca memoria.",
      "Prueba entrar nuevamente desde el lobby o historial segun el flujo.",
      "Contacta soporte si el problema se repite con descripcion visible y sin datos sensibles.",
    ],
    examples: [
      "En movil, una carga incompleta puede estar relacionada con memoria o compatibilidad WebGL.",
      "Si la interfaz carga pero el tablero queda en blanco, reporta el estado visible sin compartir claves.",
    ],
    faqs: [
      faq("Debo reinstalar algo?", "No necesariamente; XIMA carga Unity WebGL desde el navegador."),
      faq("Puedo enviar captura?", "Si, siempre que no muestre datos privados."),
    ],
    links: [
      link("Compatibilidad movil", "compatibilidad-movil"),
      link("WebGL no compatible", "solucion/webgl-no-compatible"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Ver soporte", path: "soporte" },
    sources: ["F03", "F12", "F48"],
    status: "partial",
  },
  {
    slug: "solucion/webgl-no-compatible",
    category: "solucion",
    title: "WebGL no compatible en XIMA | Que revisar",
    metaDescription:
      "Guia para revisar compatibilidad WebGL cuando XIMA no muestra el tablero o Unity no inicia correctamente.",
    h1: "WebGL no compatible",
    intro:
      "XIMA usa Unity WebGL para el tablero, por lo que el navegador y el dispositivo deben poder ejecutarlo.",
    verified:
      "El proyecto incluye build Unity WebGL y ajustes especificos para compatibilidad grafica movil.",
    usage:
      "Comprueba navegador actualizado, soporte WebGL y condiciones de memoria antes de asumir un error del juego.",
    caution:
      "No instales extensiones ni herramientas externas sugeridas por terceros sin verificar su seguridad.",
    steps: [
      "Actualiza el navegador principal del dispositivo.",
      "Evita modo privado si bloquea almacenamiento o recursos.",
      "Prueba con conexion estable.",
      "En movil, cambia orientacion si la interfaz lo requiere.",
      "Si continua, reporta navegador, dispositivo y pantalla visible a soporte.",
    ],
    examples: [
      "Un navegador antiguo puede cargar el sitio pero no el tablero 3D.",
      "Un dispositivo con poca memoria puede cerrar la escena antes de mostrarla completa.",
    ],
    faqs: [
      faq("WebGL es una cuenta de XIMA?", "No. Es una tecnologia del navegador para graficos web."),
      faq("El error expone mi cuenta?", "No por si mismo; aun asi no compartas datos sensibles al pedir ayuda."),
    ],
    links: [
      link("Unity no carga", "solucion/unity-no-carga"),
      link("Movil WebGL", "movil/webgl"),
      link("Compatibilidad movil", "compatibilidad-movil"),
    ],
    cta: { label: "Ver movil WebGL", path: "movil/webgl" },
    sources: ["F48", "F03"],
    status: "partial",
  },
  {
    slug: "solucion/microfono-bloqueado",
    category: "solucion",
    title: "Microfono bloqueado en XIMA | Voz y permisos",
    metaDescription:
      "Pasos para revisar el permiso del microfono en control por voz o chat de voz de XIMA.",
    h1: "Microfono bloqueado",
    intro:
      "El microfono puede usarse para control por voz o chat de voz, siempre con permiso del navegador.",
    verified:
      "El servicio de control por voz muestra estados de permiso pendiente, permiso rechazado y reconocimiento no compatible.",
    usage:
      "Revisa permisos del sitio, estado del navegador y botones de voz antes de reportar.",
    caution:
      "No digas contrasenas, datos sensibles ni informacion personal mientras el microfono este activo.",
    steps: [
      "Abre la funcion de voz que quieres usar.",
      "Cuando el navegador lo solicite, permite el microfono si confias en el sitio oficial.",
      "Si fue rechazado, abre permisos del sitio y cambia Microfono a permitir.",
      "Vuelve a activar control por voz o chat de voz desde la interfaz.",
      "Si el navegador no soporta reconocimiento, usa controles normales.",
    ],
    examples: [
      "Control por voz puede mostrar Permiso del microfono rechazado.",
      "Chat de voz puede pedir tocar una bocina o activar audio por una restriccion del navegador.",
    ],
    faqs: [
      faq("XIMA puede usar voz sin permiso?", "No. El navegador debe conceder acceso al microfono."),
      faq("Que hago si mi navegador no soporta voz?", "Usa controles manuales o prueba otro navegador compatible."),
    ],
    links: [
      link("Control por voz", "control-por-voz"),
      link("Permisos de microfono", "voz/permisos-microfono"),
      link("Chat de voz", "chat-de-voz"),
    ],
    cta: { label: "Ver permisos de microfono", path: "voz/permisos-microfono" },
    sources: ["F27", "F28", "F29"],
  },
  {
    slug: "solucion/idioma-no-cambia",
    category: "solucion",
    title: "El idioma no cambia en XIMA | Ajustes e idiomas",
    metaDescription:
      "Que revisar si XIMA no cambia de idioma: selector, preferencia, recarga y soporte.",
    h1: "Idioma no cambia",
    intro:
      "XIMA incluye selector de idioma y servicios de traduccion del frontend.",
    verified:
      "El proyecto contiene LanguageSelector, servicio de idioma e i18n para textos de interfaz.",
    usage:
      "Verifica que el idioma fue seleccionado y que la vista se actualizo antes de reportar.",
    caution:
      "Algunos textos embebidos, capturas o contenido externo pueden no traducirse automaticamente.",
    steps: [
      "Abre Ajustes o el selector de idioma visible.",
      "Selecciona el idioma deseado.",
      "Espera que la interfaz se actualice.",
      "Recarga la pagina si algunos textos no cambian.",
      "Reporta a soporte el texto especifico que quedo sin traducir.",
    ],
    examples: [
      "Las reglas pueden cargarse con fallback al espanol si falta traduccion.",
      "Un video externo conserva el idioma del propio video.",
    ],
    faqs: [
      faq("El idioma cambia todas las paginas?", "El sistema traduce la interfaz disponible; algunos recursos externos pueden no cambiar."),
      faq("Que debo reportar?", "La pantalla y el texto exacto que no cambio."),
    ],
    links: [
      link("Idiomas", "idiomas"),
      link("Ajustes", "ajustes"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Ver idiomas", path: "idiomas" },
    sources: ["F25", "F49", "F03"],
  },
  {
    slug: "solucion/no-puedo-crear-partida",
    category: "solucion",
    title: "No puedo crear partida en XIMA | Guia de revision",
    metaDescription:
      "Pasos para revisar modo, jugadores, tiempo, conexion y sesion cuando no puedes crear una partida en XIMA.",
    h1: "No puedo crear partida",
    intro:
      "Crear partida depende de opciones visibles como modo, jugadores, tiempo y estado de sesion.",
    verified:
      "La pantalla Crear partida permite elegir modo, numero de jugadores y tiempo por turno.",
    usage:
      "Revisa que los campos requeridos esten completos y que la interfaz no muestre un bloqueo claro.",
    caution:
      "No compartas contrasenas ni tokens si solicitas soporte.",
    steps: [
      "Abre Crear partida desde el menu o lobby.",
      "Selecciona un modo disponible.",
      "Elige cantidad de jugadores permitida.",
      "Selecciona tiempo por turno visible.",
      "Si falla, vuelve al lobby y reporta el mensaje visible a soporte.",
    ],
    examples: [
      "Una partida privada puede requerir contrasena si activas ese flujo.",
      "Una dificultad puede aparecer en flujos con bot, pero no debe confundirse con jugadores humanos.",
    ],
    faqs: [
      faq("Que opciones estan verificadas?", "Modo, 2 a 4 jugadores y tiempos visibles como 1, 2, 5 y 10 minutos aparecen documentados."),
      faq("Debo reiniciar todo?", "Primero revisa la seleccion y vuelve al lobby."),
    ],
    links: [
      link("Crear partida", "tutoriales/crear-partida"),
      link("Seleccionar modo", "tutoriales/seleccionar-modo"),
      link("Tiempo por turno", "tutoriales/tiempo-por-turno"),
    ],
    cta: { label: "Ver crear partida", path: "tutoriales/crear-partida" },
    sources: ["F11", "F12", "F32"],
  },
  {
    slug: "solucion/no-puedo-unirme-partida",
    category: "solucion",
    title: "No puedo unirme a una partida XIMA | Solucion",
    metaDescription:
      "Revisa listado, contrasena, invitacion y estado de partida si no puedes unirte a una partida de XIMA.",
    h1: "No puedo unirme a partida",
    intro:
      "Unirse a una partida puede depender del listado, disponibilidad, contrasena o invitacion.",
    verified:
      "Los listados de partidas y las invitaciones de amigos existen en el frontend y backend de XIMA.",
    usage:
      "Confirma que la partida sigue disponible y que usas el flujo correcto: publica, privada o invitacion.",
    caution:
      "No publiques contrasenas de partidas privadas ni datos de otros usuarios.",
    steps: [
      "Abre el listado de partidas disponibles o la invitacion recibida.",
      "Verifica que la partida no este llena ni finalizada.",
      "Si es privada, introduce la contrasena solo en el campo oficial.",
      "Si es de amigo, acepta la invitacion desde Amigos.",
      "Si sigue fallando, reporta el mensaje visible sin exponer la contrasena.",
    ],
    examples: [
      "Una partida privada puede rechazar entrada si la contrasena no coincide.",
      "Una invitacion vencida o partida llena puede impedir unirse aunque el enlace exista.",
    ],
    faqs: [
      faq("Unirme a publica y privada es igual?", "No. La privada puede pedir contrasena."),
      faq("Puedo compartir una contrasena en soporte?", "No. Describe el problema sin revelar la clave."),
    ],
    links: [
      link("Unirse a privada", "tutoriales/unirse-partida-privada"),
      link("Contrasena de partida", "tutoriales/contrasena-de-partida"),
      link("Unirse partida amigo", "tutoriales/unirse-partida-amigo"),
    ],
    cta: { label: "Ver unirse a privada", path: "tutoriales/unirse-partida-privada" },
    sources: ["F12", "F21", "F32", "F34"],
  },
  {
    slug: "solucion/no-veo-amigos",
    category: "solucion",
    title: "No veo mis amigos en XIMA | Que revisar",
    metaDescription:
      "Pasos para revisar buscador, solicitudes, perfil y conexion si no ves amigos en XIMA.",
    h1: "No veo amigos",
    intro:
      "La seccion Amigos permite buscar jugadores, enviar solicitudes y gestionar relaciones visibles.",
    verified:
      "El frontend y backend incluyen Friends, FriendProfile, FriendInvite y Friendship.",
    usage:
      "Revisa si estas en la pantalla correcta, si hay solicitudes pendientes o si el jugador aun no acepto.",
    caution:
      "No publiques codigos de jugador de terceros sin permiso.",
    steps: [
      "Abre Amigos desde el menu principal.",
      "Usa el buscador con el codigo o nombre visible del jugador.",
      "Revisa solicitudes recibidas y enviadas.",
      "Confirma si la amistad fue aceptada.",
      "Reporta solo el estado visible si la lista no actualiza.",
    ],
    examples: [
      "Un jugador puede aparecer como solicitud pendiente antes de estar en la lista.",
      "El perfil de amigo puede abrir replay si existe y esta disponible.",
    ],
    faqs: [
      faq("Necesito codigo de jugador?", "Puede ayudar a ubicar a la persona correcta."),
      faq("Puedo ver datos privados de amigos?", "No se deben publicar ni exponer datos privados."),
    ],
    links: [
      link("Amigos", "amigos"),
      link("Buscar jugador", "tutoriales/buscar-jugador"),
      link("Perfil de amigo", "perfil/amigo"),
    ],
    cta: { label: "Ver amigos", path: "amigos" },
    sources: ["F21", "F22", "F34"],
  },
  {
    slug: "solucion/tienda-no-muestra-recompensas",
    category: "solucion",
    title: "La tienda no muestra recompensas en XIMA | Revision segura",
    metaDescription:
      "Que revisar si la tienda de XIMA no muestra recompensas, saldo o productos visibles.",
    h1: "Tienda no muestra recompensas",
    intro:
      "La tienda y recompensas pueden depender de catalogo, saldo, disponibilidad y condiciones configuradas.",
    verified:
      "El proyecto contiene Store, catalogo de skins, ordenes, precios y modelos de recompensa gift card.",
    usage:
      "Revisa la tienda desde la interfaz oficial y no asumas disponibilidad si un producto no aparece.",
    caution:
      "No se publican precios, stock, premios o condiciones legales no confirmadas por el propietario.",
    steps: [
      "Abre Tienda desde el menu principal.",
      "Revisa si aparecen productos, skins o saldo visible.",
      "Actualiza la vista si la interfaz ofrece esa accion.",
      "Comprueba si la recompensa tiene condiciones pendientes o disponibilidad diaria.",
      "Contacta soporte sin enviar datos de pago ni informacion sensible.",
    ],
    examples: [
      "Una recompensa puede no mostrarse si no esta activa o disponible.",
      "Un saldo insuficiente puede impedir una compra o reclamo segun el flujo.",
    ],
    faqs: [
      faq("Puedo asumir que una recompensa siempre esta disponible?", "No. La disponibilidad debe verla la interfaz oficial."),
      faq("Debo compartir datos de pago?", "No. No compartas datos sensibles en soporte publico."),
    ],
    links: [
      link("Tienda", "tienda"),
      link("Recompensas", "tienda/recompensas"),
      link("Reclamar recompensa", "tienda/reclamar-recompensa"),
    ],
    cta: { label: "Ver tienda", path: "tienda" },
    sources: ["F23", "F30", "F35"],
    status: "partial",
  },
  {
    slug: "solucion/puzzle-no-avanza",
    category: "solucion",
    title: "El puzzle no avanza en XIMA | Solucion",
    metaDescription:
      "Pasos para revisar modo, objetivo, turno, tiempo y estado si un puzzle de XIMA no avanza.",
    h1: "Puzzle no avanza",
    intro:
      "Los puzzles son flujos de entrenamiento y pueden tener objetivo, tiempo o estado de completado.",
    verified:
      "El lobby contiene paneles de puzzles, busqueda, modos, recompensa y estados completado/fallido.",
    usage:
      "Comprueba objetivo y condicion del puzzle antes de intentar reintentar o pasar al siguiente.",
    caution:
      "No se deben prometer recompensas de puzzle sin reglas aprobadas.",
    steps: [
      "Abre el puzzle desde el panel correspondiente.",
      "Lee el objetivo visible, como llegar a la cima o resolver en tiempo.",
      "Haz una jugada legal segun las reglas del modo.",
      "Si falla, revisa si el puzzle quedo completado o fallido.",
      "Usa Reintentar o Siguiente puzzle si la interfaz lo muestra.",
    ],
    examples: [
      "Un puzzle puede no avanzar si el objetivo no se cumplio.",
      "Un limite de tiempo o turnos puede cerrar el intento como fallido.",
    ],
    faqs: [
      faq("Puzzles tienen modos?", "Si. El panel usa etiquetas de modo como Ciencia, Azar y otros segun datos disponibles."),
      faq("Que hago si se bloquea?", "Reintenta desde la interfaz y reporta el estado visible si persiste."),
    ],
    links: [
      link("Puzzles", "puzzles"),
      link("Abrir puzzle", "tutoriales/abrir-puzzle"),
      link("Reintentar puzzle", "tutoriales/reintentar-puzzle"),
    ],
    cta: { label: "Ver puzzles", path: "puzzles" },
    sources: ["F12", "F08"],
    status: "partial",
  },
  {
    slug: "solucion/ranking-no-actualiza",
    category: "solucion",
    title: "Ranking no actualiza en XIMA | Que significa",
    metaDescription:
      "Revisa datos de ranking, modos, leaderboard y actualizacion visible si el ranking de XIMA no cambia.",
    h1: "Ranking no actualiza",
    intro:
      "El ranking depende de datos de leaderboard y modos visibles; no siempre cambia inmediatamente despues de mirar una pantalla.",
    verified:
      "El frontend consulta ranking por modos y estadisticas usan datos de leaderboard de torneos ganados por modo.",
    usage:
      "Revisa el modo, actualiza la vista y compara con estadisticas propias cuando existan.",
    caution:
      "No publiques identificadores internos ni datos de otros jugadores para reclamar posiciones.",
    steps: [
      "Abre Ranking desde el menu.",
      "Selecciona el modo que quieres revisar.",
      "Actualiza o vuelve a cargar la vista si la interfaz lo permite.",
      "Compara con tus estadisticas visibles si tienes partidas registradas.",
      "Contacta soporte si el dato no coincide con una partida confirmada.",
    ],
    examples: [
      "Ranking Ciencia y Ranking Azar pueden tener listas separadas.",
      "Una partida sin registro suficiente puede no reflejarse como esperabas.",
    ],
    faqs: [
      faq("Ranking y estadisticas son iguales?", "No. Ranking compara tablas; estadisticas muestran datos propios."),
      faq("El ranking siempre cambia al instante?", "La guia no confirma actualizacion instantanea."),
    ],
    links: [
      link("Ranking", "ranking"),
      link("Ranking por modo", "ranking/por-modo"),
      link("Estadisticas", "estadisticas"),
    ],
    cta: { label: "Ver ranking", path: "ranking" },
    sources: ["F20", "F19", "F32"],
    status: "partial",
  },
  {
    slug: "solucion/historial-vacio",
    category: "solucion",
    title: "Historial vacio en XIMA | Por que puede pasar",
    metaDescription:
      "Que revisar si el historial de XIMA aparece vacio: filtros, partidas terminadas, modo y registro disponible.",
    h1: "Historial vacio",
    intro:
      "Historial muestra partidas registradas; si aparece vacio, revisa filtros y disponibilidad.",
    verified:
      "La interfaz de historial incluye filtros de modo, resultado, fecha, busqueda y actualizacion.",
    usage:
      "Limpia filtros antes de asumir que no existe registro de partidas.",
    caution:
      "No se debe exponer historial privado de usuarios en capturas publicas.",
    steps: [
      "Abre Historial desde el menu.",
      "Quita filtros de modo, resultado, fecha o jugador.",
      "Pulsa Actualizar historial si la accion esta disponible.",
      "Comprueba si tus partidas terminaron y quedaron registradas.",
      "Contacta soporte si una partida finalizada propia no aparece.",
    ],
    examples: [
      "Un filtro por Azar puede ocultar partidas de Ciencia.",
      "Una partida sin replay puede aparecer distinto a una partida con repeticion.",
    ],
    faqs: [
      faq("Historial vacio significa que perdi datos?", "No necesariamente; puede ser un filtro o falta de partidas registradas."),
      faq("Debo compartir mi historial completo?", "No. Comparte solo lo necesario y sin datos sensibles."),
    ],
    links: [
      link("Historial", "historial"),
      link("Actualizar historial", "tutoriales/actualizar-historial"),
      link("No hay replay", "solucion/no-hay-replay"),
    ],
    cta: { label: "Ver historial", path: "historial" },
    sources: ["F18", "F33"],
  },
  {
    slug: "solucion/replay-no-reproduce",
    category: "solucion",
    title: "Replay no reproduce en XIMA | Solucion de problemas",
    metaDescription:
      "Pasos para revisar si un replay de XIMA no reproduce: disponibilidad, controles, carga Unity y partida registrada.",
    h1: "Replay no reproduce",
    intro:
      "Un replay requiere datos guardados y una vista de reproduccion funcionando.",
    verified:
      "El proyecto incluye control de replay, timeline, estados de reproduccion y mensajes cuando no hay replay guardado.",
    usage:
      "Distingue entre replay ausente, replay cargando y control pausado.",
    caution:
      "No compartas datos privados del match al solicitar ayuda.",
    steps: [
      "Confirma que la tarjeta muestre replay disponible.",
      "Pulsa Reproducir o Ver replay desde Historial o Ver partidos.",
      "Espera a que el tablero cargue antes de usar controles.",
      "Prueba Pausar/Reproducir y Reiniciar si la timeline esta visible.",
      "Si no carga, revisa Unity no carga o contacta soporte.",
    ],
    examples: [
      "Una partida puede mostrar No hay replay guardado.",
      "Un replay puede necesitar que Unity cargue antes de avanzar pasos.",
    ],
    faqs: [
      faq("Replay no reproduce si no existe?", "Correcto. La interfaz puede indicar que no hay replay guardado."),
      faq("Debo revisar WebGL?", "Si el tablero no carga, revisa la guia de Unity/WebGL."),
    ],
    links: [
      link("No hay replay", "solucion/no-hay-replay"),
      link("Unity no carga", "solucion/unity-no-carga"),
      link("Controles replay", "replay/controles"),
    ],
    cta: { label: "Ver controles replay", path: "replay/controles" },
    sources: ["F18", "F33", "F12"],
  },
  {
    slug: "solucion/dados-no-aparecen",
    category: "solucion",
    title: "Dados no aparecen en XIMA | Modo Azar",
    metaDescription:
      "Que revisar si los dados no aparecen en XIMA: modo activo, partida correcta, UI de dados y compatibilidad.",
    h1: "Dados no aparecen",
    intro:
      "Los dados corresponden a Modo Azar y flujos relacionados; no deben esperarse en Modo Ciencia.",
    verified:
      "Modo Ciencia oculta dados visibles, mientras Modo Azar usa scripts Dice y DiceUI.",
    usage:
      "Comprueba primero el modo de la partida antes de reportar ausencia de dados.",
    caution:
      "No se deben asumir dados en modos que no los usan.",
    steps: [
      "Mira el modo de la partida actual.",
      "Si estas en Ciencia, no esperes dados visibles.",
      "Si estas en Azar, espera el turno o estado donde la tirada deba mostrarse.",
      "Recarga la partida si la UI parece incompleta.",
      "Reporta soporte solo con modo, pantalla visible y sin datos sensibles.",
    ],
    examples: [
      "En Ciencia, no ver dados es comportamiento esperado segun la guia.",
      "En Azar, los dados forman parte del flujo de movimiento.",
    ],
    faqs: [
      faq("Dados deben aparecer en Ciencia?", "No."),
      faq("Que fuente confirma los dados?", "Los scripts Dice y DiceUI de Unity y la documentacion de Modo Azar."),
    ],
    links: [
      link("Modo Azar", "azar"),
      link("Modo Ciencia", "ciencia"),
      link("Dados en Azar", "azar/dados"),
    ],
    cta: { label: "Ver dados en Azar", path: "azar/dados" },
    sources: ["F08", "F42", "F43"],
  },
  {
    slug: "solucion/bot-no-inicia",
    category: "solucion",
    title: "Bot no inicia en XIMA | Practica con IA",
    metaDescription:
      "Pasos seguros si la partida con bot no inicia: modo, dificultad, carga Unity, sesion y soporte.",
    h1: "Bot no inicia",
    intro:
      "El flujo de bot depende de la pantalla Jugar con bot, modo, dificultad y carga correcta del tablero.",
    verified:
      "El frontend incluye PlayBot y el proyecto contiene rutas y scripts de IA para practica.",
    usage:
      "Revisa configuracion visible antes de considerar que el bot fallo.",
    caution:
      "No se publican endpoints ni detalles internos del bot.",
    steps: [
      "Abre Jugar con bot desde el menu o lobby.",
      "Selecciona modo y dificultad visibles.",
      "Inicia la partida y espera la carga de Unity.",
      "Si no aparece tablero, revisa Unity no carga.",
      "Si el bot no responde, reporta modo, dificultad y estado visible.",
    ],
    examples: [
      "Un fallo de carga puede ser del tablero, no del bot.",
      "Una dificultad no confirmada no debe tratarse como garantia de comportamiento.",
    ],
    faqs: [
      faq("El bot tiene modos?", "La interfaz muestra opciones de modo y dificultad segun el flujo."),
      faq("Debo reiniciar PM2 o backend?", "Como jugador no. Eso corresponde a mantenimiento del servidor."),
    ],
    links: [
      link("Bots", "bots"),
      link("Dificultad de bot", "bots/dificultad"),
      link("Unity no carga", "solucion/unity-no-carga"),
    ],
    cta: { label: "Ver bots", path: "bots" },
    sources: ["F13", "F38"],
    status: "partial",
  },
  {
    slug: "cuenta/crear-cuenta",
    category: "cuenta",
    title: "Crear cuenta en XIMA | Registro y verificacion",
    metaDescription:
      "Guia para crear una cuenta en XIMA con correo, contrasena, terminos y verificacion cuando aplique.",
    h1: "Crear cuenta",
    intro:
      "Crear cuenta permite acceder como usuario registrado y aceptar los terminos desde el flujo oficial.",
    verified:
      "RegisterForm solicita correo, contrasena, acepta terminos y el backend maneja verificacion de email.",
    usage:
      "Usa siempre el formulario oficial y un correo valido cuando quieras conservar cuenta.",
    caution:
      "No compartas contrasenas ni codigos de verificacion con nadie.",
    steps: [
      "Abre la pantalla de registro.",
      "Ingresa un correo valido.",
      "Escribe una contrasena en el campo oficial.",
      "Lee y acepta Terminos y Condiciones desde el modal.",
      "Revisa tu correo si la interfaz solicita verificacion.",
    ],
    examples: [
      "Si falta contrasena, el formulario muestra validacion.",
      "Si el correo ya existe, el backend puede rechazar el registro.",
    ],
    faqs: [
      faq("Necesito aceptar terminos?", "Si. El flujo de registro incluye aceptacion de terminos."),
      faq("Debo publicar mi correo?", "No. El correo es dato personal."),
    ],
    links: [
      link("Iniciar sesion", "cuenta/iniciar-sesion"),
      link("Terminos y condiciones", "cuenta/terminos-y-condiciones"),
      link("Privacidad", "cuenta/privacidad"),
    ],
    cta: { label: "Ver iniciar sesion", path: "cuenta/iniciar-sesion" },
    sources: ["F31", "F29"],
  },
  {
    slug: "cuenta/iniciar-sesion",
    category: "cuenta",
    title: "Iniciar sesion en XIMA | Acceso de jugador",
    metaDescription:
      "Aprende como iniciar sesion en XIMA y que revisar si necesitas verificar email o usar invitado.",
    h1: "Iniciar sesion",
    intro:
      "El inicio de sesion usa identificador y contrasena desde el formulario oficial de XIMA.",
    verified:
      "LoginForm maneja usuario, contrasena, acceso invitado cuando esta disponible y verificacion de email.",
    usage:
      "Inicia sesion solo desde el sitio oficial y revisa mensajes visibles si el acceso falla.",
    caution:
      "Nunca compartas tu contrasena ni pegues tokens en soporte.",
    steps: [
      "Abre la pantalla de inicio de sesion.",
      "Ingresa tu usuario, correo o identificador segun el formulario.",
      "Escribe la contrasena.",
      "Acepta terminos si el flujo lo solicita.",
      "Si aparece verificacion pendiente, revisa el correo asociado.",
    ],
    examples: [
      "El formulario puede mostrar Login Failed si los datos no coinciden.",
      "Una cuenta con email pendiente puede requerir verificacion antes de entrar.",
    ],
    faqs: [
      faq("Puedo jugar sin registrarme?", "El LoginForm incluye un flujo de invitado cuando esta permitido."),
      faq("Que hago si falla?", "Revisa datos y mensajes visibles antes de contactar soporte."),
    ],
    links: [
      link("Crear cuenta", "cuenta/crear-cuenta"),
      link("Seguridad de cuenta", "cuenta/seguridad"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Ver seguridad", path: "cuenta/seguridad" },
    sources: ["F31", "F29"],
  },
  {
    slug: "cuenta/cerrar-sesion",
    category: "cuenta",
    title: "Cerrar sesion en XIMA | Guia rapida",
    metaDescription:
      "Como cerrar sesion en XIMA desde el menu principal y que significa para la cuenta en el navegador.",
    h1: "Cerrar sesion",
    intro:
      "Cerrar sesion sale de la cuenta activa en el navegador y devuelve el control al flujo de acceso.",
    verified:
      "El menu principal visible incluye Cerrar sesion en el layout autenticado.",
    usage:
      "Usa esta accion cuando termines de jugar en un dispositivo compartido.",
    caution:
      "Cerrar sesion no debe confundirse con eliminar cuenta o borrar datos del servidor.",
    steps: [
      "Abre el menu principal de XIMA.",
      "Busca el boton Cerrar sesion.",
      "Pulsa la accion cuando quieras salir de la cuenta activa.",
      "Confirma que vuelves al flujo de acceso o pantalla publica.",
      "En dispositivos compartidos, cierra tambien el navegador si hace falta.",
    ],
    examples: [
      "Cerrar sesion es recomendable antes de dejar un equipo de otra persona.",
      "Si quieres cambiar de cuenta, cierra sesion y entra con el otro usuario.",
    ],
    faqs: [
      faq("Cerrar sesion borra mi cuenta?", "No. Solo sale de la sesion actual."),
      faq("Donde aparece?", "En el menu principal autenticado de XIMA."),
    ],
    links: [
      link("Perfil", "perfil"),
      link("Iniciar sesion", "cuenta/iniciar-sesion"),
      link("Seguridad", "cuenta/seguridad"),
    ],
    cta: { label: "Ver iniciar sesion", path: "cuenta/iniciar-sesion" },
    sources: ["F02", "F31"],
  },
  {
    slug: "cuenta/terminos-y-condiciones",
    category: "cuenta",
    title: "Terminos y condiciones en XIMA | Donde aparecen",
    metaDescription:
      "Aprende donde aparecen los Terminos y Condiciones en XIMA y como se aceptan en registro o juego invitado.",
    h1: "Terminos y condiciones",
    intro:
      "XIMA muestra terminos durante flujos de registro y acceso invitado mediante un modal de aceptacion.",
    verified:
      "El proyecto incluye TermsAcceptanceModal y contenido de terminos en multiples idiomas.",
    usage:
      "Lee el contenido antes de aceptar y usa el idioma disponible en el modal si necesitas cambiar lectura.",
    caution:
      "Esta guia no sustituye el texto legal completo mostrado por la plataforma.",
    steps: [
      "Abre registro o juego como invitado.",
      "Cuando aparezca el modal, selecciona el idioma disponible si lo necesitas.",
      "Lee el contenido dentro del panel.",
      "Marca la casilla de aceptacion correspondiente.",
      "Pulsa Aceptar y continuar solo si estas de acuerdo.",
    ],
    examples: [
      "El registro usa una etiqueta de aceptacion distinta al modo invitado.",
      "El modal puede mostrar contenido traducido desde el archivo de terminos.",
    ],
    faqs: [
      faq("Esta pagina es el contrato completo?", "No. La referencia valida es el texto mostrado oficialmente por XIMA."),
      faq("Puedo jugar sin aceptar?", "El flujo oficial puede requerir aceptacion para continuar."),
    ],
    links: [
      link("Crear cuenta", "cuenta/crear-cuenta"),
      link("Privacidad", "cuenta/privacidad"),
      link("Iniciar sesion", "cuenta/iniciar-sesion"),
    ],
    cta: { label: "Ver crear cuenta", path: "cuenta/crear-cuenta" },
    sources: ["F29", "F31"],
    status: "partial",
  },
  {
    slug: "cuenta/privacidad",
    category: "cuenta",
    title: "Privacidad en XIMA | Cuenta, voz y datos visibles",
    metaDescription:
      "Guia publica sobre privacidad en XIMA: perfil, amigos, voz, terminos y datos que no debes compartir.",
    h1: "Privacidad",
    intro:
      "La privacidad en XIMA se documenta aqui como buenas practicas y referencias a flujos reales.",
    verified:
      "Terminos, perfil, amigos, voz y soporte contienen puntos donde pueden aparecer datos personales o comunicacion.",
    usage:
      "Comparte solo informacion necesaria y evita datos reales en ejemplos publicos.",
    caution:
      "No publiques correos, telefonos, contrasenas, claves, tokens, direcciones ni conversaciones privadas.",
    steps: [
      "Revisa que datos son visibles en perfil o amigos.",
      "No escribas informacion sensible en campos publicos.",
      "Evita activar voz si vas a decir datos privados.",
      "Al pedir soporte, borra datos personales de capturas.",
      "Consulta terminos oficiales para el detalle legal.",
    ],
    examples: [
      "Un codigo de jugador puede ayudar a ubicar una cuenta sin publicar correo.",
      "Una captura de tienda no debe mostrar datos de pago o direccion.",
    ],
    faqs: [
      faq("Esta guia reemplaza la politica legal?", "No. Es una ayuda de uso basada en funciones visibles."),
      faq("Que datos nunca comparto?", "Contrasenas, tokens, claves, datos de pago y datos personales."),
    ],
    links: [
      link("Terminos y condiciones", "cuenta/terminos-y-condiciones"),
      link("Perfil", "perfil"),
      link("Chat de voz", "chat-de-voz"),
    ],
    cta: { label: "Ver seguridad", path: "cuenta/seguridad" },
    sources: ["F29", "F21", "F22", "F28"],
    status: "partial",
  },
  {
    slug: "cuenta/codigo-de-jugador",
    category: "cuenta",
    title: "Codigo de jugador en XIMA | Identificacion publica",
    metaDescription:
      "Aprende para que sirve el codigo de jugador en XIMA y como usarlo con amigos, perfil y busqueda.",
    h1: "Codigo de jugador de cuenta",
    intro:
      "El codigo de jugador ayuda a identificar una cuenta dentro de flujos sociales sin publicar el correo.",
    verified:
      "El perfil y amigos usan datos visibles de jugador, y ya existe guia de codigo de jugador en Perfil.",
    usage:
      "Usalo para buscar o confirmar una persona dentro de la interfaz oficial.",
    caution:
      "No publiques codigos de terceros sin permiso y no los confundas con contrasenas.",
    steps: [
      "Abre Perfil para revisar tus datos visibles.",
      "Ubica el codigo o identificador mostrado por la interfaz.",
      "Compártelo solo con quien quieres agregar o invitar.",
      "En Amigos, usa el buscador para localizar otro jugador.",
      "Verifica el perfil antes de enviar solicitud.",
    ],
    examples: [
      "El codigo puede evitar confundir usuarios con nombres parecidos.",
      "No sustituye credenciales de acceso ni contrasena.",
    ],
    faqs: [
      faq("El codigo permite iniciar sesion?", "No se documenta como contrasena; es dato visible de identificacion social."),
      faq("Donde lo uso?", "En flujos de amigos, perfil y busqueda de jugador."),
    ],
    links: [
      link("Codigo de jugador de perfil", "perfil/codigo-de-jugador"),
      link("Buscar jugador", "tutoriales/buscar-jugador"),
      link("Amigos", "amigos"),
    ],
    cta: { label: "Ver buscar jugador", path: "tutoriales/buscar-jugador" },
    sources: ["F21", "F22", "F34"],
  },
  {
    slug: "cuenta/seguridad",
    category: "cuenta",
    title: "Seguridad de cuenta en XIMA | Buenas practicas",
    metaDescription:
      "Buenas practicas de seguridad para cuenta XIMA: contrasena, email, sesion, voz, soporte y datos privados.",
    h1: "Seguridad de cuenta",
    intro:
      "La seguridad de cuenta empieza por usar solo formularios oficiales y proteger credenciales.",
    verified:
      "El proyecto maneja contrasenas con hash en backend y borra campos sensibles del perfil expuesto.",
    usage:
      "Usa una contrasena propia, verifica correo cuando aplique y cierra sesion en dispositivos compartidos.",
    caution:
      "No se revelan detalles internos de seguridad ni se publican endpoints de autenticacion.",
    steps: [
      "Crea cuenta desde el formulario oficial.",
      "Usa una contrasena que no compartas con otros servicios.",
      "Verifica tu email si la plataforma lo solicita.",
      "Cierra sesion en dispositivos ajenos.",
      "Contacta soporte sin enviar contrasenas ni tokens.",
    ],
    examples: [
      "Un mensaje de verificacion pendiente significa revisar correo, no compartir codigo publicamente.",
      "Cerrar sesion ayuda en computadoras compartidas.",
    ],
    faqs: [
      faq("Esta guia explica seguridad interna?", "No. Solo buenas practicas publicas."),
      faq("Debo enviar mi contrasena a soporte?", "No. Nunca."),
    ],
    links: [
      link("Crear cuenta", "cuenta/crear-cuenta"),
      link("Cerrar sesion", "cuenta/cerrar-sesion"),
      link("Privacidad", "cuenta/privacidad"),
    ],
    cta: { label: "Ver privacidad", path: "cuenta/privacidad" },
    sources: ["F31", "F29"],
  },
  {
    slug: "tienda/bonos",
    category: "tienda",
    title: "Bonos en XIMA | Tienda y recompensas",
    metaDescription:
      "Que se puede explicar publicamente sobre bonos en XIMA, saldo X y recompensas visibles sin prometer premios.",
    h1: "Bonos",
    intro:
      "Los bonos se tratan como parte de tienda, saldo o recompensas visibles cuando la interfaz los muestra.",
    verified:
      "El proyecto contiene walletBalance, productos, precios y recompensas, pero las condiciones comerciales requieren cautela.",
    usage:
      "Revisa bonos desde la tienda o paneles visibles y no asumas disponibilidad fuera de la interfaz oficial.",
    caution:
      "No se publican cantidades, premios ni condiciones si no estan aprobadas.",
    steps: [
      "Abre Tienda desde el menu.",
      "Revisa saldo o productos visibles.",
      "Busca si la interfaz menciona bono o recompensa.",
      "Lee condiciones antes de intentar canjear.",
      "Consulta soporte si el bono esperado no aparece.",
    ],
    examples: [
      "Un bono puede estar asociado a saldo X o recompensas configuradas.",
      "Una recompensa de torneo o puzzle puede requerir confirmacion aparte.",
    ],
    faqs: [
      faq("Los bonos siempre estan disponibles?", "No. Dependen de configuracion y condiciones visibles."),
      faq("Esta pagina publica precios?", "No. Evita datos comerciales no confirmados."),
    ],
    links: [
      link("Tienda", "tienda"),
      link("Saldo", "tienda/saldo"),
      link("Recompensas", "tienda/recompensas"),
    ],
    cta: { label: "Ver saldo", path: "tienda/saldo" },
    sources: ["F23", "F35"],
    status: "partial",
  },
  {
    slug: "tienda/saldo",
    category: "tienda",
    title: "Saldo X en XIMA | Como leerlo en tienda",
    metaDescription:
      "Aprende que es el saldo X visible en XIMA y como se relaciona con tienda, compras y recompensas.",
    h1: "Saldo X",
    intro:
      "El saldo X aparece en la logica de tienda y recompensas como valor de cuenta usado por ciertos productos.",
    verified:
      "El backend usa walletBalance y valida saldo insuficiente antes de compras o reclamos de recompensas.",
    usage:
      "Lee el saldo desde la interfaz oficial antes de intentar comprar o reclamar.",
    caution:
      "No se deben publicar saldos reales de usuarios ni condiciones comerciales sin aprobacion.",
    steps: [
      "Abre Tienda.",
      "Busca el saldo visible o informacion de producto.",
      "Compara el saldo con el precio mostrado por la interfaz.",
      "No continues si el producto requiere datos que no quieres compartir.",
      "Si el saldo no coincide, contacta soporte con captura sin datos sensibles.",
    ],
    examples: [
      "El backend puede responder saldo insuficiente si no alcanza para el producto.",
      "El saldo no debe compartirse como dato publico de cuenta.",
    ],
    faqs: [
      faq("Saldo X es dinero real?", "Esta guia no define equivalencias comerciales; solo describe el dato visible del proyecto."),
      faq("Donde se verifica?", "En Store y en controladores/modelos de ordenes."),
    ],
    links: [
      link("Tienda", "tienda"),
      link("Comprar skin", "tienda/comprar-skin"),
      link("Reclamar recompensa", "tienda/reclamar-recompensa"),
    ],
    cta: { label: "Ver tienda", path: "tienda" },
    sources: ["F23", "F35", "F31"],
    status: "partial",
  },
  {
    slug: "tienda/comprar-skin",
    category: "tienda",
    title: "Comprar skin en XIMA | Guia de tienda",
    metaDescription:
      "Pasos para revisar una skin en la tienda de XIMA, validar precio visible y usar el flujo oficial.",
    h1: "Comprar skin",
    intro:
      "Las skins son productos visibles en tienda y catalogo; algunas aplican al bloque especial o estilos asociados.",
    verified:
      "El proyecto incluye Store, skinStoreCatalog y administradores de skins especiales en Unity.",
    usage:
      "Compra solo desde la tienda oficial, revisando imagen, nombre, precio y disponibilidad.",
    caution:
      "No se prometen productos, precios ni disponibilidad fuera de lo que la tienda muestre.",
    steps: [
      "Abre Tienda desde el menu.",
      "Selecciona una skin visible en el catalogo.",
      "Revisa nombre, imagen, precio y descripcion.",
      "Confirma que tienes saldo suficiente si el producto usa saldo X.",
      "Completa la compra solo desde el flujo oficial.",
    ],
    examples: [
      "El catalogo contiene colecciones de skins especiales.",
      "Una skin ganada puede tener condiciones distintas a una skin comprable.",
    ],
    faqs: [
      faq("Todas las skins cuestan lo mismo?", "No se debe asumir; revisa precio visible en tienda."),
      faq("Puedo comprar fuera del sitio?", "La guia solo respalda el flujo oficial de XIMA."),
    ],
    links: [
      link("Skins", "tienda/skins"),
      link("Saldo X", "tienda/saldo"),
      link("Equipar skin", "tienda/equipar-skin"),
    ],
    cta: { label: "Ver skins", path: "tienda/skins" },
    sources: ["F23", "F30", "F46", "F35"],
    status: "partial",
  },
  {
    slug: "tienda/equipar-skin",
    category: "tienda",
    title: "Equipar skin en XIMA | Perfil y bloque especial",
    metaDescription:
      "Aprende como se relacionan skins, perfil y bloque especial en XIMA sin inventar pasos no confirmados.",
    h1: "Equipar skin",
    intro:
      "Equipar una skin significa usar una apariencia disponible en las secciones de perfil, tienda o personalizacion.",
    verified:
      "Unity contiene UI y administradores de skins de bloque especial; el perfil y tienda enlazan personalizacion.",
    usage:
      "Revisa primero si la skin esta disponible para tu cuenta y despues usa la seccion de personalizacion visible.",
    caution:
      "Los nombres finales de botones para equipar deben verificarse con una captura actual antes de publicarse como texto exacto.",
    steps: [
      "Abre Perfil o la seccion de personalizacion visible.",
      "Revisa las skins o avatares disponibles para tu cuenta.",
      "Selecciona la skin que quieres usar.",
      "Confirma o guarda si la interfaz lo solicita.",
      "Entra a una partida o vuelve al perfil para comprobar el cambio visible.",
    ],
    examples: [
      "Una skin de bloque especial puede afectar como se reconoce tu pieza clave.",
      "Una skin no disponible no debe aparecer como opcion equipable.",
    ],
    faqs: [
      faq("Esta guia confirma el nombre exacto del boton?", "No. Marca pendiente la etiqueta final hasta revisar captura actual."),
      faq("Skins y avatar son iguales?", "No necesariamente; perfil puede incluir avatar y la tienda skins."),
    ],
    links: [
      link("Avatar de perfil", "perfil/avatar"),
      link("Skins", "tienda/skins"),
      link("Editar perfil", "tutoriales/editar-perfil"),
    ],
    cta: { label: "Ver avatar", path: "perfil/avatar" },
    sources: ["F22", "F23", "F30", "F46"],
    status: "partial",
  },
  {
    slug: "tienda/gift-cards",
    category: "tienda",
    title: "Gift cards en XIMA | Recompensa pendiente de confirmacion",
    metaDescription:
      "Pagina noindex sobre gift cards en XIMA hasta confirmar condiciones publicas, disponibilidad y lenguaje legal.",
    h1: "Gift cards",
    intro:
      "El backend contiene modelos y rutas de gift card, pero su publicacion SEO requiere aprobacion.",
    verified:
      "Existen controladores y modelos de disponibilidad diaria, reclamo y configuracion de gift card.",
    usage:
      "Esta pagina solo registra la funcion como tema pendiente para evitar prometer recompensas no confirmadas.",
    caution:
      "No se deben publicar importes, stock, elegibilidad ni fechas sin confirmacion del propietario.",
    steps: [
      "Verifica si la tienda muestra gift cards en la interfaz oficial.",
      "Lee disponibilidad y condiciones visibles antes de reclamar.",
      "No publiques datos de contacto o direccion en ejemplos.",
      "Marca la guia como pendiente si falta texto legal aprobado.",
      "Mantiene noindex hasta confirmacion final.",
    ],
    examples: [
      "La existencia de backend no basta para anunciar una promocion publica.",
      "Una disponibilidad diaria debe aparecer en la interfaz para explicarse al usuario.",
    ],
    faqs: [
      faq("Esta pagina se indexa?", "No. Queda noindex hasta aprobacion."),
      faq("Por que no se publican detalles?", "Porque involucra recompensas y condiciones comerciales."),
    ],
    links: [
      link("Tienda", "tienda"),
      link("Reclamar recompensa", "tienda/reclamar-recompensa"),
      link("Privacidad", "cuenta/privacidad"),
    ],
    cta: { label: "Ver tienda", path: "tienda" },
    sources: ["F35", "F23"],
    status: "ownerConfirmation",
  },
  {
    slug: "tienda/reclamar-recompensa",
    category: "tienda",
    title: "Reclamar recompensa en XIMA | Revision segura",
    metaDescription:
      "Guia prudente para reclamar recompensas en XIMA cuando la tienda muestra disponibilidad y condiciones.",
    h1: "Reclamar recompensa",
    intro:
      "El reclamo de recompensa debe hacerse solo si la interfaz oficial muestra disponibilidad y requisitos.",
    verified:
      "El backend valida perfil de recompensa, saldo, disponibilidad diaria y registro de reclamo para ciertos productos.",
    usage:
      "Lee todos los campos visibles y evita enviar informacion incompleta o sensible fuera del formulario oficial.",
    caution:
      "Las condiciones finales, elegibilidad y lenguaje comercial requieren confirmacion humana.",
    steps: [
      "Abre Tienda y localiza la recompensa visible.",
      "Revisa precio, disponibilidad y requisitos mostrados.",
      "Completa solo los campos oficiales necesarios para el reclamo.",
      "Confirma que aceptas las condiciones si la interfaz lo solicita.",
      "Guarda el estado visible del reclamo sin publicar datos personales.",
    ],
    examples: [
      "El backend puede rechazar un reclamo por saldo insuficiente.",
      "Un producto sin disponibilidad diaria no debe anunciarse como disponible.",
    ],
    faqs: [
      faq("Puedo reclamar sin requisitos?", "No se debe asumir; sigue lo que muestre la interfaz."),
      faq("Que datos protejo?", "Nombre real, contacto, direccion, saldo y cualquier dato de pago."),
    ],
    links: [
      link("Recompensas", "tienda/recompensas"),
      link("Gift cards", "tienda/gift-cards"),
      link("Saldo X", "tienda/saldo"),
    ],
    cta: { label: "Ver recompensas", path: "tienda/recompensas" },
    sources: ["F35", "F23", "F29"],
    status: "partial",
  },
  {
    slug: "voz/comandos-camara",
    category: "voz",
    title: "Comandos de voz para mover la camara en XIMA",
    metaDescription:
      "Aprende que puedes decir para cambiar la vista del tablero de XIMA con la voz: girar, acercar, alejar y centrar.",
    h1: "Mover la camara con la voz",
    intro:
      "Con el control por voz puedes cambiar la vista del tablero sin tocar la pantalla, usando frases para girar, acercar, alejar o centrar la camara.",
    headings: ["Que puedes hacer", "Como se activa", "Cuando usar controles manuales"],
    verified:
      "XIMA reconoce frases relacionadas con camara, vista, giro, acercar, alejar, centrar tablero y mirar caras del tablero.",
    usage:
      "Activa control por voz, acepta el microfono y di una frase clara relacionada con la vista que quieres cambiar.",
    caution:
      "Si la voz no se reconoce bien, espera un momento y usa los controles manuales de camara.",
    stepsTitle: "Comandos de voz",
    stepsNote: "Prueba frases cortas y claras. La disponibilidad puede variar segun navegador, microfono y pantalla.",
    steps: [
      "Di \"girar izquierda\" o \"girar derecha\" para cambiar el angulo del tablero.",
      "Di \"acercar\" o \"mas zoom\" para ver el tablero mas cerca.",
      "Di \"alejar\" o \"menos zoom\" para abrir la vista.",
      "Di \"centrar tablero\" para volver a una vista ordenada.",
      "Di \"mirar cara uno\", \"cara dos\", \"cara tres\" o \"cara cuatro\" para orientar la vista hacia una cara.",
    ],
    examples: [
      "Si el tablero queda demasiado lejos, prueba con acercar.",
      "Si perdiste la orientacion, prueba con centrar tablero.",
    ],
    faqs: [
      faq("Los comandos funcionan en todos los navegadores?", "No. Dependen de soporte de reconocimiento y microfono."),
      faq("Necesito chat de voz para camara?", "No. Control por voz y chat de voz son funciones distintas."),
    ],
    links: [
      link("Control por voz", "control-por-voz"),
      link("Permisos microfono", "voz/permisos-microfono"),
      link("Compatibilidad movil", "compatibilidad-movil"),
    ],
    cta: { label: "Ver control por voz", path: "control-por-voz" },
    sources: ["F27", "F45"],
  },
  {
    slug: "voz/comandos-dados",
    category: "voz",
    title: "Comandos de dados por voz en XIMA",
    metaDescription:
      "Como usar comandos de voz para lanzar dados en modos compatibles de XIMA, con permisos y limites.",
    h1: "Comandos de dados",
    intro:
      "En modos con dados, puedes usar la voz para pedir que XIMA lance los dados cuando sea el momento correcto.",
    headings: ["Que puedes decir", "Donde usarlo", "Cuando no aparece"],
    verified:
      "XIMA reconoce frases como lanzar dados, lanza dados, tirar dados, tira dados o dados.",
    usage:
      "Usa estos comandos en Modo Azar o en una pantalla donde los dados sean parte de la jugada.",
    caution:
      "No esperes dados en Modo Ciencia; si no hay dados visibles, revisa el modo activo.",
    stepsTitle: "Comandos de voz",
    steps: [
      "Activa Control por voz.",
      "Acepta el permiso de microfono cuando aparezca la solicitud del navegador.",
      "En una partida con dados, di \"lanzar dados\", \"tirar dados\" o simplemente \"dados\".",
      "Espera a que XIMA termine de escuchar y muestre el resultado.",
      "Lee el resultado antes de mover.",
    ],
    examples: [
      "Lanzar dados por voz se relaciona con Modo Azar.",
      "Si el navegador rechaza microfono, el comando no podra ejecutarse.",
    ],
    faqs: [
      faq("Puedo lanzar dados por voz en Ciencia?", "No deberias esperarlo porque Ciencia no usa dados visibles."),
      faq("Que pasa si digo mal el comando?", "El servicio puede no reconocerlo; usa controles manuales si falla."),
    ],
    links: [
      link("Lanzar dados", "tutoriales/lanzar-dados"),
      link("Dados no aparecen", "solucion/dados-no-aparecen"),
      link("Modo Azar", "azar"),
    ],
    cta: { label: "Ver lanzar dados", path: "tutoriales/lanzar-dados" },
    sources: ["F27", "F42"],
  },
  {
    slug: "voz/comandos-movimiento",
    category: "voz",
    title: "Comandos de voz para mover bloques en XIMA",
    metaDescription:
      "Aprende como usar la voz para intentar mover bloques en XIMA sin olvidar que cada jugada debe respetar las reglas.",
    h1: "Mover bloques con la voz",
    intro:
      "El control por voz puede ayudarte a expresar movimientos del tablero, pero la jugada sigue dependiendo de las reglas de XIMA.",
    headings: ["Que puedes hacer", "Como se usa", "La regla siempre decide"],
    verified:
      "XIMA reconoce palabras como mover, mueve, seleccionar, confirmar y referencias a casillas cuando la pantalla permite usarlas.",
    usage:
      "Usa voz como entrada alternativa, pero la jugada sigue sujeta a reglas de movimiento.",
    caution:
      "Un comando reconocido no garantiza que la jugada sea legal.",
    stepsTitle: "Como usar la voz",
    steps: [
      "Activa Control por voz y acepta el permiso de microfono.",
      "Selecciona o indica una celda de origen si el flujo lo requiere.",
      "Di una frase de movimiento como \"mover\" junto con la direccion o casilla cuando corresponda.",
      "Revisa la respuesta visual antes de confirmar la jugada.",
      "Si la jugada no es legal, corrige con las reglas de movimiento.",
    ],
    examples: [
      "Puedes usar la voz como ayuda, pero no reemplaza revisar origen, ruta y destino.",
      "Si XIMA entiende otra casilla, cancela o usa controles manuales antes de confirmar.",
    ],
    faqs: [
      faq("Voz salta las reglas?", "No. Solo es una forma de entrada."),
      faq("Que hago si interpreta otra celda?", "No confirmes la jugada y usa controles manuales."),
    ],
    links: [
      link("Sistema de movimientos", "reglas/movimientos"),
      link("Control por voz", "control-por-voz"),
      link("Coordenadas", "reglas/coordenadas"),
    ],
    cta: { label: "Ver movimientos", path: "reglas/movimientos" },
    sources: ["F27", "F41", "F45"],
  },
  {
    slug: "voz/permisos-microfono",
    category: "voz",
    title: "Permisos de microfono en XIMA | Voz",
    metaDescription:
      "Guia para permitir, revisar o corregir permisos de microfono en control por voz y chat de voz de XIMA.",
    h1: "Permisos de microfono",
    intro:
      "Control por voz y chat de voz necesitan permiso del navegador para usar el microfono.",
    headings: ["Permiso del microfono", "Como activarlo", "Cuidado con tu voz"],
    verified:
      "XIMA te avisa cuando el microfono esta pendiente, rechazado, no disponible o listo para usarse.",
    usage:
      "Gestiona permisos desde el navegador y activa voz solo cuando quieras hablar o usar comandos.",
    caution:
      "Evita decir informacion sensible mientras cualquier funcion de microfono este activa.",
    steps: [
      "Abre la funcion de voz en XIMA.",
      "Acepta el permiso cuando el navegador pregunte.",
      "Si lo rechazaste, abre configuracion del sitio y cambia Microfono a permitir.",
      "Vuelve a XIMA y activa la funcion otra vez.",
      "Si no funciona, revisa compatibilidad del navegador.",
    ],
    examples: [
      "El estado Permiso del microfono rechazado indica bloqueo del navegador o usuario.",
      "Reconocimiento no compatible significa que ese navegador no permite usar comandos de voz.",
    ],
    faqs: [
      faq("Microfono y altavoz son lo mismo?", "No. El microfono captura voz; el altavoz reproduce audio."),
      faq("Chat de voz usa los mismos permisos?", "Tambien necesita microfono para hablar."),
    ],
    links: [
      link("Microfono bloqueado", "solucion/microfono-bloqueado"),
      link("Chat de voz", "chat-de-voz"),
      link("Control por voz", "control-por-voz"),
    ],
    cta: { label: "Ver microfono bloqueado", path: "solucion/microfono-bloqueado" },
    sources: ["F27", "F28", "F29"],
  },
  {
    slug: "movil/orientacion",
    category: "movil",
    title: "Orientacion movil en XIMA | Pantalla y tablero",
    metaDescription:
      "Consejos para usar XIMA en celular con orientacion vertical u horizontal, menu inferior, tablero y paneles visibles.",
    h1: "Orientacion movil",
    intro:
      "En movil, la orientacion de pantalla puede afectar espacio disponible para tablero, menu y controles.",
    headings: ["Vertical y horizontal", "Como navegar", "Espacio disponible"],
    verified:
      "XIMA adapta menus, paneles y controles cuando la pantalla es pequena.",
    usage:
      "Usa la orientacion que permita ver tablero, botones y paneles sin superposiciones.",
    caution:
      "En vertical algunas opciones pueden verse contraidas o mas abajo; en horizontal suele haber mas espacio para tablero y replay.",
    stepsTitle: "Que revisar en movil",
    steps: [
      "Abre XIMA en el navegador movil compatible.",
      "Entra al lobby o a la partida.",
      "Gira el dispositivo si el tablero o controles quedan comprimidos.",
      "Usa menu inferior cuando aparezca en movil.",
      "Si el tablero no carga, revisa navegador, memoria del dispositivo o la guia de solucion de problemas.",
    ],
    examples: [
      "Una partida puede ser mas comoda en horizontal si el tablero ocupa mucho espacio.",
      "El menu inferior facilita navegacion cuando el menu superior no cabe.",
    ],
    faqs: [
      faq("XIMA tiene vista movil?", "El proyecto contiene compatibilidad y menu movil."),
      faq("La orientacion arregla todos los problemas?", "No. Tambien influyen memoria, navegador y carga del tablero."),
    ],
    links: [
      link("Compatibilidad movil", "compatibilidad-movil"),
      link("Menu inferior", "movil/menu-inferior"),
      link("Carga del tablero", "movil/webgl"),
    ],
    cta: { label: "Ver compatibilidad movil", path: "compatibilidad-movil" },
    sources: ["F02", "F12", "F45", "F48"],
    status: "partial",
  },
  {
    slug: "movil/webgl",
    category: "movil",
    title: "Carga del tablero en celular | Compatibilidad movil XIMA",
    metaDescription:
      "Aprende que revisar si el tablero de XIMA tarda en cargar o no aparece en celular o tablet.",
    h1: "Carga del tablero en celular",
    intro:
      "El tablero de XIMA necesita un celular capaz de mostrar graficos del juego dentro del navegador.",
    headings: ["Que necesita el tablero", "Como mejorar la carga", "Cuando pedir ayuda"],
    verified:
      "XIMA incluye ajustes para mejorar la carga del tablero en navegadores y dispositivos moviles compatibles.",
    usage:
      "Prueba con navegador actualizado, memoria disponible y conexion estable.",
    caution:
      "Algunos dispositivos antiguos pueden no ejecutar la escena con fluidez.",
    stepsTitle: "Que revisar",
    steps: [
      "Actualiza el navegador movil.",
      "Cierra apps o pestanas pesadas antes de cargar la partida.",
      "Entra a XIMA desde el sitio oficial.",
      "Espera la carga del tablero antes de tocar controles repetidamente.",
      "Si no funciona, revisa la guia El navegador no carga el tablero.",
    ],
    examples: [
      "Una pantalla negra puede estar relacionada con memoria, navegador o carga grafica.",
      "Una carga lenta no siempre indica error de cuenta.",
    ],
    faqs: [
      faq("Funciona en todos los telefonos?", "No. Depende del dispositivo, memoria disponible y navegador."),
      faq("Debo instalar app?", "Esta guia habla del uso web; la disponibilidad de app se trata por separado."),
    ],
    links: [
      link("El navegador no carga el tablero", "solucion/webgl-no-compatible"),
      link("El tablero no carga", "solucion/unity-no-carga"),
      link("Movil", "compatibilidad-movil"),
    ],
    cta: { label: "Ver carga del tablero", path: "solucion/webgl-no-compatible" },
    sources: ["F48", "F03"],
    status: "partial",
  },
  {
    slug: "movil/menu-lobby",
    category: "movil",
    title: "Menu del lobby en movil | XIMA",
    metaDescription:
      "Como usar el menu del lobby de XIMA en celular para entrar a Aprender, partidas, historial, amigos y tienda.",
    h1: "Menu del lobby en movil",
    intro:
      "El lobby concentra accesos a modos, aprender, historial, estadisticas, tienda, ver partidos, amigos y soporte.",
    headings: ["Que ves en el lobby", "Como moverte", "Pantallas compactas"],
    verified:
      "El lobby y el menu principal se adaptan para que las secciones importantes sigan disponibles en pantallas reducidas.",
    usage:
      "Usa los botones de navegacion visibles para cambiar de seccion sin perder el contexto.",
    caution:
      "No todas las vistas tienen la misma densidad en movil; algunas requieren desplazamiento.",
    stepsTitle: "Como navegar en movil",
    steps: [
      "Abre XIMA en movil e inicia sesion si corresponde.",
      "Ubica el menu principal o inferior.",
      "Toca Lobby para volver al centro de navegacion.",
      "Elige Aprender, Ver partidos, Amigos o Tienda segun objetivo.",
      "Usa volver al lobby si una guia o vista te deja lejos del inicio.",
    ],
    examples: [
      "Aprender puede usarse para buscar guias sin salir del ecosistema.",
      "Ver partidos permite mirar partidas o tarjetas cuando estan disponibles.",
    ],
    faqs: [
      faq("El menu cambia en movil?", "Puede adaptarse para pantallas pequenas."),
      faq("Puedo usar Aprender en movil?", "Si, la seccion esta dentro de la navegacion."),
    ],
    links: [
      link("Lobby", "lobby"),
      link("Menu inferior", "movil/menu-inferior"),
      link("Boton Aprender", "interfaz/boton-aprender"),
    ],
    cta: { label: "Ver lobby", path: "lobby" },
    sources: ["F02", "F10", "F12"],
  },
  {
    slug: "movil/jugar-en-celular",
    category: "movil",
    title: "Jugar XIMA en celular | Guia movil",
    metaDescription:
      "Consejos para jugar XIMA en celular: navegador, orientacion, menu movil, voz, tablero y replay.",
    h1: "Jugar en celular",
    intro:
      "Jugar en celular es posible desde la experiencia web cuando el dispositivo soporta las funciones necesarias.",
    headings: ["Antes de jugar", "Como prepararte", "Rendimiento"],
    verified:
      "XIMA incluye compatibilidad movil, menu inferior, carga del tablero y controles de camara tactil.",
    usage:
      "Prepara el dispositivo antes de entrar a una partida: bateria, conexion, navegador y espacio de pantalla.",
    caution:
      "La experiencia puede variar segun telefono, sistema operativo, memoria disponible y navegador.",
    steps: [
      "Usa un navegador movil actualizado.",
      "Entra al sitio oficial de XIMA.",
      "Coloca el dispositivo en la orientacion mas comoda.",
      "Entra a una partida, bot, puzzle o replay.",
      "Si hay fallos de carga, revisa carga del tablero en movil y soporte.",
    ],
    examples: [
      "Un replay puede ser mas facil de revisar en horizontal.",
      "Control por voz puede depender de permisos del navegador movil.",
    ],
    faqs: [
      faq("Necesito instalar algo?", "La guia cubre el uso web; sigue lo que indique la plataforma oficial."),
      faq("Puedo usar voz en celular?", "Depende de permisos y compatibilidad del navegador."),
    ],
    links: [
      link("Orientacion movil", "movil/orientacion"),
      link("Carga del tablero", "movil/webgl"),
      link("Control por voz", "control-por-voz"),
    ],
    cta: { label: "Ver orientacion movil", path: "movil/orientacion" },
    sources: ["F02", "F12", "F27", "F45", "F48"],
    status: "partial",
  },
  {
    slug: "replay/eventos",
    category: "replay",
    title: "Eventos de replay en XIMA | Timeline y jugadas",
    metaDescription:
      "Aprende a leer eventos de replay en XIMA usando timeline, anotacion, dados y cambios de posicion.",
    h1: "Eventos de replay",
    intro:
      "Los eventos de replay son cambios registrados que permiten reconstruir una partida paso a paso.",
    verified:
      "Replay y backend de MatchHistory contienen datos de partida, timeline y eventos usados para reproduccion.",
    usage:
      "Usa eventos para ubicar capturas, movimientos, dados o cambios importantes sin ver toda la partida de corrido.",
    caution:
      "No todos los matches tienen replay guardado o datos completos para publicar.",
    steps: [
      "Abre un replay disponible.",
      "Mira la timeline o lista de pasos.",
      "Avanza de evento en evento.",
      "Relaciona cada evento con movimiento, dado o estado visible.",
      "Pausa en el evento que quieras analizar.",
    ],
    examples: [
      "Un evento puede representar un movimiento de bloque.",
      "En Azar, un evento puede ayudar a leer la tirada asociada.",
    ],
    faqs: [
      faq("Evento y turno son iguales?", "No siempre; la guia los usa como cambios registrados en replay."),
      faq("Todos los replays tienen eventos claros?", "Depende del registro disponible."),
    ],
    links: [
      link("Timeline", "replay/timeline"),
      link("Leer anotacion", "replay/leer-anotacion"),
      link("No hay replay", "solucion/no-hay-replay"),
    ],
    cta: { label: "Ver timeline", path: "replay/timeline" },
    sources: ["F18", "F33", "F42"],
    status: "partial",
  },
  {
    slug: "replay/leer-anotacion",
    category: "replay",
    title: "Leer anotacion en replay XIMA | Guia practica",
    metaDescription:
      "Como leer la anotacion de una partida XIMA desde replay, coordenadas, movimientos y ejemplos seguros.",
    h1: "Leer anotacion",
    intro:
      "La anotacion ayuda a conectar lo que ves en el tablero con la secuencia de jugadas registrada.",
    verified:
      "La base de conocimiento incluye sistema de anotacion y el replay se relaciona con datos de partida.",
    usage:
      "Lee la anotacion junto al tablero, no como texto aislado.",
    caution:
      "Los formatos exactos de anotacion avanzada deben confirmarse antes de ejemplos definitivos.",
    steps: [
      "Abre una partida con replay disponible.",
      "Ubica la anotacion o informacion de movimiento si aparece.",
      "Compara origen, destino y pieza con el tablero.",
      "Usa pausa o paso a paso para evitar perder el cambio.",
      "Consulta coordenadas si necesitas ubicar una casilla.",
    ],
    examples: [
      "Una anotacion puede ayudarte a recordar que bloque se movio.",
      "Coordenadas del tablero ayudan a explicar origen y destino sin capturas sensibles.",
    ],
    faqs: [
      faq("La anotacion reemplaza el tablero?", "No. Complementa la vista del replay."),
      faq("Puedo publicar una anotacion?", "Solo si no contiene datos privados y el material esta permitido."),
    ],
    links: [
      link("Sistema de anotacion", "sistema-de-anotacion"),
      link("Coordenadas", "reglas/coordenadas"),
      link("Eventos de replay", "replay/eventos"),
    ],
    cta: { label: "Ver anotacion", path: "sistema-de-anotacion" },
    sources: ["F08", "F18", "F33", "F41"],
    status: "partial",
  },
  {
    slug: "replay/estudiar-errores",
    category: "replay",
    title: "Estudiar errores con replay en XIMA",
    metaDescription:
      "Aprende a usar replay para estudiar errores de movimiento, riesgo, captura, rescate y decisiones en XIMA.",
    h1: "Estudiar errores con replay",
    intro:
      "Replay permite volver a un turno y revisar si el problema fue regla, decision o lectura de posicion.",
    verified:
      "El proyecto tiene controles de replay, velocidad, timeline y guias de historial.",
    usage:
      "Estudia un error por vez para sacar conclusiones claras.",
    caution:
      "No uses replay para exponer o ridiculizar a jugadores.",
    steps: [
      "Elige una partida con un error que quieras revisar.",
      "Reproduce hasta el turno anterior al error.",
      "Pausa y observa que opciones legales existian.",
      "Avanza la jugada y mira la consecuencia.",
      "Escribe una regla o decision que revisar en la proxima partida.",
    ],
    examples: [
      "Un error de altura se detecta comparando destino y nivel de la columna.",
      "Un error de riesgo aparece cuando el especial queda capturable.",
    ],
    faqs: [
      faq("Necesito ver todo el replay?", "No. Ve directo al tramo del error."),
      faq("Que pasa si no hay replay?", "Usa historial disponible y la guia de no hay replay."),
    ],
    links: [
      link("Error", "diccionario/error"),
      link("Aprender de una derrota", "articulos/aprender-de-una-derrota"),
      link("Controles replay", "replay/controles"),
    ],
    cta: { label: "Ver controles replay", path: "replay/controles" },
    sources: ["F18", "F33", "F08"],
  },
  {
    slug: "replay/compartir-aprendizaje",
    category: "replay",
    title: "Compartir aprendizaje de replay en XIMA",
    metaDescription:
      "Como compartir aprendizajes de una partida XIMA sin exponer datos privados ni detalles no autorizados.",
    h1: "Compartir aprendizaje",
    intro:
      "Compartir un aprendizaje de replay puede ayudar, pero debe hacerse sin revelar informacion privada.",
    verified:
      "El replay y perfiles pueden mostrar datos de partidas o jugadores; por eso la privacidad es parte del flujo.",
    usage:
      "Comparte conclusiones generales, no datos personales ni identificadores privados.",
    caution:
      "No publiques partidas, perfiles o replays de terceros sin permiso.",
    steps: [
      "Elige una jugada o concepto, no toda la informacion de la partida.",
      "Anonimiza nombres o datos si vas a publicar una captura.",
      "Describe la regla o decision aprendida.",
      "Enlaza a la guia publica relacionada.",
      "Evita publicar codigos, contrasenas o datos de cuenta.",
    ],
    examples: [
      "Seguro: aprendi que el especial no debe quedar sin apoyo.",
      "No seguro: publicar identificadores completos de jugadores sin permiso.",
    ],
    faqs: [
      faq("Puedo compartir replay de otros?", "Solo con permiso o si el contenido es publicable por la plataforma."),
      faq("Que comparto mejor?", "La regla aprendida y una conclusion breve."),
    ],
    links: [
      link("Privacidad", "cuenta/privacidad"),
      link("Analisis", "diccionario/analisis"),
      link("Replay", "historial-y-replay"),
    ],
    cta: { label: "Ver privacidad", path: "cuenta/privacidad" },
    sources: ["F18", "F22", "F33", "F29"],
    status: "partial",
  },
  {
    slug: "estadisticas/interpretar-cimax",
    category: "progreso",
    title: "Interpretar CIMAX en XIMA | Guia de estadisticas",
    metaDescription:
      "Aprende a leer CIMAX en XIMA como metrica visible de progreso sin convertirla en evaluacion absoluta.",
    h1: "Interpretar CIMAX",
    intro:
      "CIMAX aparece como una metrica del producto y debe leerse dentro de su modo y contexto.",
    verified:
      "El proyecto contiene UI de CIMAX, tracker, puntuacion y calculo backend de cimaxScoring.",
    usage:
      "Compara CIMAX por modo y revisa partidas que pudieron influir en el dato.",
    caution:
      "No uses CIMAX para hacer afirmaciones absolutas sobre una persona.",
    steps: [
      "Abre Estadisticas.",
      "Localiza paneles CIMAX visibles.",
      "Revisa si el valor pertenece a Ciencia, Cienzar, Contrazar o Azar.",
      "Compara con historial o partidas recientes.",
      "Usa el dato como referencia de progreso dentro de XIMA.",
    ],
    examples: [
      "CIMAX Ciencia y CIMAX Azar se muestran por separado.",
      "Un cambio de CIMAX debe leerse junto al modo y partidas jugadas.",
    ],
    faqs: [
      faq("CIMAX es ranking?", "No exactamente. Ranking ordena jugadores; CIMAX es una metrica visible."),
      faq("Debo comparar modos distintos?", "Con cuidado, porque cada modo tiene contexto diferente."),
    ],
    links: [
      link("CIMAX", "estadisticas/cimax"),
      link("Glosario CIMAX", "glosario/cimax"),
      link("Estadisticas", "estadisticas"),
    ],
    cta: { label: "Ver CIMAX", path: "estadisticas/cimax" },
    sources: ["F19", "F47"],
    status: "partial",
  },
  {
    slug: "estadisticas/comparar-modos",
    category: "progreso",
    title: "Comparar modos en estadisticas XIMA",
    metaDescription:
      "Como leer estadisticas por modo en XIMA: Ciencia, Cienzar, Contrazar y Azar con cautela.",
    h1: "Comparar modos",
    intro:
      "Las estadisticas de XIMA separan datos por modo para evitar mezclar experiencias distintas.",
    verified:
      "Stats define columnas y etiquetas para Ciencia, Cienzar, Contrazar y Azar.",
    usage:
      "Compara cada modo con su propio contexto: sin dados, con dados o pendiente de confirmacion hibrida.",
    caution:
      "Cienzar y Contrazar requieren prudencia editorial en explicaciones publicas avanzadas.",
    steps: [
      "Abre Estadisticas.",
      "Busca la seccion de rendimiento por modo.",
      "Lee valores de Ciencia, Cienzar, Contrazar y Azar por separado.",
      "Relaciona cada dato con partidas de ese modo.",
      "No saques conclusiones globales sin revisar historial.",
    ],
    examples: [
      "Una mejora en Azar puede venir de decisiones con dados.",
      "Un dato de Ciencia debe compararse con partidas de Ciencia, no con todas las partidas.",
    ],
    faqs: [
      faq("Por que separar modos?", "Porque cada modo cambia el contexto de decision."),
      faq("Contrazar esta explicado completo?", "No. Algunas reglas publicas siguen pendientes."),
    ],
    links: [
      link("Estadisticas", "estadisticas"),
      link("CIMAX Ciencia", "estadisticas/cimax-ciencia"),
      link("CIMAX Azar", "estadisticas/cimax-azar"),
    ],
    cta: { label: "Ver estadisticas", path: "estadisticas" },
    sources: ["F19", "F47"],
    status: "partial",
  },
  {
    slug: "estadisticas/leer-progreso",
    category: "progreso",
    title: "Leer progreso en XIMA | Estadisticas y replay",
    metaDescription:
      "Aprende a leer progreso en XIMA con partidas, victorias, derrotas, tiempo, rachas, CIMAX y replay.",
    h1: "Leer progreso",
    intro:
      "El progreso en XIMA combina numeros visibles y revision de partidas.",
    verified:
      "Stats muestra partidas, victorias, derrotas, tiempo, rachas, bloques capturados y datos por modo.",
    usage:
      "Usa estadisticas para detectar patrones y replay para explicar decisiones concretas.",
    caution:
      "No interpretes datos incompletos como conclusion definitiva.",
    steps: [
      "Abre Estadisticas.",
      "Revisa resumen general de partidas, victorias y derrotas.",
      "Mira modo favorito y datos por modo.",
      "Selecciona una partida reciente en Historial para explicar un cambio.",
      "Define un objetivo de practica para la proxima sesion.",
    ],
    examples: [
      "Una racha de victorias puede coincidir con practicar un modo concreto.",
      "Muchos bloques capturados no garantizan haber jugado bien si el objetivo final fallo.",
    ],
    faqs: [
      faq("Progreso es solo ganar?", "No. Tambien puede ser entender mejor reglas y decisiones."),
      faq("Que hago con una mala estadistica?", "Busca una causa en replay y practica una guia relacionada."),
    ],
    links: [
      link("Estadisticas", "estadisticas"),
      link("Historial", "historial"),
      link("Aprender de una derrota", "articulos/aprender-de-una-derrota"),
    ],
    cta: { label: "Ver estadisticas", path: "estadisticas" },
    sources: ["F19", "F18", "F33"],
  },
  {
    slug: "ranking/leer-tabla",
    category: "ranking",
    title: "Leer la tabla de ranking en XIMA",
    metaDescription:
      "Como interpretar una tabla de ranking en XIMA por jugador, modo, posicion y datos visibles.",
    h1: "Leer tabla de ranking",
    intro:
      "El ranking ordena informacion visible de jugadores segun datos del modo o leaderboard disponible.",
    verified:
      "Ranking y endpoints de leaderboard por modos existen en frontend y backend.",
    usage:
      "Lee posicion, modo y dato mostrado antes de comparar jugadores.",
    caution:
      "No publiques datos personales ni asumas reglas de desempate no confirmadas.",
    steps: [
      "Abre Ranking desde el menu.",
      "Selecciona el modo o tabla que quieres revisar.",
      "Lee encabezados y posicion de cada fila.",
      "Compara solo jugadores del mismo modo.",
      "Consulta perfil publico si la interfaz lo permite y respeta privacidad.",
    ],
    examples: [
      "Ranking Ciencia y Ranking Azar pueden mostrar contextos distintos.",
      "Una fila no explica por si sola como se jugo la partida.",
    ],
    faqs: [
      faq("Ranking muestra informacion privada?", "Debe mostrar solo datos visibles de la plataforma."),
      faq("Puedo comparar todos los modos juntos?", "Hazlo con cuidado; cada modo tiene reglas y contexto distintos."),
    ],
    links: [
      link("Ranking", "ranking"),
      link("Ranking por modo", "ranking/por-modo"),
      link("Perfil", "perfil"),
    ],
    cta: { label: "Ver ranking", path: "ranking" },
    sources: ["F20", "F32", "F22"],
    status: "partial",
  },
  {
    slug: "ranking/competir-por-modo",
    category: "ranking",
    title: "Competir por modo en ranking XIMA",
    metaDescription:
      "Aprende como se organizan rankings por modo en XIMA y que revisar antes de comparar posiciones.",
    h1: "Competir por modo",
    intro:
      "Competir por modo significa leer resultados dentro del contexto de Ciencia, Cienzar, Contrazar o Azar.",
    verified:
      "Ranking y estadisticas separan modos como Ciencia, Cienzar, Contrazar y Azar.",
    usage:
      "Elige el modo que practicas y compara datos dentro de esa misma lista.",
    caution:
      "Las reglas publicas de algunos modos hibridos siguen pendientes; no se deben publicar ventajas no confirmadas.",
    steps: [
      "Abre Ranking.",
      "Selecciona el modo que quieres consultar.",
      "Revisa posicion, nombre visible y dato principal.",
      "Compara con tus estadisticas del mismo modo.",
      "Usa replay para estudiar partidas que influyeron en tu resultado.",
    ],
    examples: [
      "Un jugador puede destacar en Ciencia y tener otro rendimiento en Azar.",
      "Contrazar se menciona en estadisticas, pero su explicacion publica requiere cautela.",
    ],
    faqs: [
      faq("Por que competir por modo?", "Porque cada modo cambia las decisiones y condiciones visibles."),
      faq("Debo usar ranking para aprender?", "Puede orientar objetivos, pero replay explica mejor las jugadas."),
    ],
    links: [
      link("Ranking por modo", "ranking/por-modo"),
      link("Comparar modos", "estadisticas/comparar-modos"),
      link("Historial y replay", "historial-y-replay"),
    ],
    cta: { label: "Ver ranking por modo", path: "ranking/por-modo" },
    sources: ["F20", "F19", "F32"],
    status: "partial",
  },
  {
    slug: "amigos/privacidad",
    category: "comunidad",
    title: "Privacidad con amigos en XIMA",
    metaDescription:
      "Buenas practicas para usar amigos, perfiles, invitaciones y replays en XIMA sin exponer datos privados.",
    h1: "Privacidad en amigos",
    intro:
      "La seccion Amigos facilita conectar jugadores, pero debe usarse cuidando datos visibles y permisos.",
    verified:
      "Friends, FriendProfile, invitaciones y modelos de amistad existen en frontend y backend.",
    usage:
      "Comparte solo lo necesario para buscar o invitar y revisa perfiles dentro de la interfaz oficial.",
    caution:
      "No publiques codigos, nombres reales, chats o replays privados sin consentimiento.",
    steps: [
      "Abre Amigos desde el menu.",
      "Busca jugadores con datos visibles, como codigo de jugador.",
      "Envia solicitud solo a personas que reconoces.",
      "Revisa perfil de amigo sin compartir datos externos.",
      "Antes de compartir replay, confirma que sea publico o autorizado.",
    ],
    examples: [
      "Un codigo ayuda a encontrar a un amigo sin pedir correo.",
      "Una invitacion de partida no debe publicarse si contiene acceso privado.",
    ],
    faqs: [
      faq("Puedo compartir mi codigo?", "Si quieres que te agreguen, pero evita compartir el de otros sin permiso."),
      faq("Amigos muestra todo mi historial?", "La guia no confirma exposicion total; revisa solo lo visible en la interfaz."),
    ],
    links: [
      link("Amigos", "amigos"),
      link("Codigo de jugador", "cuenta/codigo-de-jugador"),
      link("Privacidad", "cuenta/privacidad"),
    ],
    cta: { label: "Ver amigos", path: "amigos" },
    sources: ["F21", "F22", "F34"],
    status: "partial",
  },
  {
    slug: "amigos/invitaciones",
    category: "comunidad",
    title: "Invitaciones de amigos en XIMA | Partidas",
    metaDescription:
      "Como funcionan las invitaciones de amigos en XIMA para jugar partidas o aceptar invitaciones visibles.",
    h1: "Invitaciones de amigos",
    intro:
      "Las invitaciones conectan la seccion Amigos con partidas disponibles o solicitudes de juego.",
    verified:
      "El frontend contiene flujos de invitar amigo a partida, aceptar invitacion y unirse a partida de amigo.",
    usage:
      "Revisa origen de la invitacion y estado de la partida antes de aceptar.",
    caution:
      "No publiques invitaciones privadas ni contrasenas de sala.",
    steps: [
      "Abre Amigos o notificaciones relacionadas.",
      "Busca una invitacion pendiente.",
      "Verifica de quien viene y a que partida apunta.",
      "Acepta si quieres entrar y la partida sigue disponible.",
      "Si no reconoces la invitacion, rechazala o ignora segun la interfaz.",
    ],
    examples: [
      "Una invitacion puede llevarte a una partida de amigo.",
      "Si la partida ya esta llena, la invitacion puede no servir.",
    ],
    faqs: [
      faq("Invitacion y solicitud de amistad son iguales?", "No. Una conecta jugadores; otra puede apuntar a jugar una partida."),
      faq("Puedo reenviar invitaciones?", "La guia no confirma reenvio; usa solo opciones visibles."),
    ],
    links: [
      link("Invitar amigo a partida", "tutoriales/invitar-amigo-a-partida"),
      link("Aceptar invitacion", "tutoriales/aceptar-invitacion-partida"),
      link("Unirse partida amigo", "tutoriales/unirse-partida-amigo"),
    ],
    cta: { label: "Ver aceptar invitacion", path: "tutoriales/aceptar-invitacion-partida" },
    sources: ["F21", "F34", "F12"],
  },
  {
    slug: "amigos/jugar-con-amigo",
    category: "comunidad",
    title: "Jugar con un amigo en XIMA | Guia social",
    metaDescription:
      "Pasos para jugar con un amigo en XIMA usando amigos, invitaciones y partidas disponibles.",
    h1: "Jugar con amigo",
    intro:
      "Jugar con un amigo combina relacion social, invitacion y entrada a una partida compatible.",
    verified:
      "El proyecto contiene amigos, invitaciones, partidas con amigos y flujos de unirse desde invitacion.",
    usage:
      "Primero confirma la amistad o la invitacion y despues entra a la partida desde el boton oficial.",
    caution:
      "No compartas contrasenas o enlaces privados fuera de canales confiables.",
    steps: [
      "Agrega o localiza a tu amigo en la seccion Amigos.",
      "Crea una partida o usa una invitacion existente.",
      "Invita al amigo desde el flujo visible.",
      "Espera que acepte o entra desde su invitacion.",
      "Comienza la partida cuando la sala este lista.",
    ],
    examples: [
      "Un amigo puede entrar mediante una invitacion de partida.",
      "Una partida privada puede requerir contrasena si el flujo la usa.",
    ],
    faqs: [
      faq("Necesito ser amigo para jugar?", "Hay partidas publicas y privadas; jugar con amigo usa flujos sociales."),
      faq("Que hago si no aparece?", "Revisa la guia No veo amigos."),
    ],
    links: [
      link("Amigos", "amigos"),
      link("No veo amigos", "solucion/no-veo-amigos"),
      link("Crear partida privada", "tutoriales/crear-partida-privada"),
    ],
    cta: { label: "Ver amigos", path: "amigos" },
    sources: ["F21", "F34", "F12"],
  },
  {
    slug: "amigos/solicitudes",
    category: "comunidad",
    title: "Solicitudes de amistad en XIMA",
    metaDescription:
      "Como enviar, aceptar, rechazar o cancelar solicitudes de amistad en XIMA desde la interfaz de Amigos.",
    h1: "Solicitudes de amistad",
    intro:
      "Las solicitudes de amistad organizan el permiso social antes de interactuar como amigos dentro de XIMA.",
    verified:
      "Existen guias y backend para enviar, aceptar, rechazar y cancelar solicitudes de amistad.",
    usage:
      "Gestiona solicitudes desde Amigos y revisa perfiles antes de aceptar.",
    caution:
      "Acepta solo usuarios que reconozcas y evita publicar datos de terceros.",
    steps: [
      "Abre Amigos.",
      "Busca un jugador o revisa solicitudes pendientes.",
      "Envia, acepta, rechaza o cancela segun corresponda.",
      "Confirma que el estado cambio en la interfaz.",
      "Usa perfil de amigo para revisar informacion visible despues.",
    ],
    examples: [
      "Una solicitud enviada puede cancelarse antes de ser aceptada.",
      "Una solicitud recibida puede aceptarse o rechazarse.",
    ],
    faqs: [
      faq("Aceptar solicitud crea amistad?", "Si el flujo lo confirma, el jugador pasa a la relacion de amigos."),
      faq("Puedo deshacer siempre?", "La guia solo confirma acciones visibles ya documentadas."),
    ],
    links: [
      link("Enviar solicitud", "tutoriales/enviar-solicitud-amistad"),
      link("Aceptar solicitud", "tutoriales/aceptar-solicitud-amistad"),
      link("Cancelar solicitud", "tutoriales/cancelar-solicitud-amistad"),
    ],
    cta: { label: "Ver enviar solicitud", path: "tutoriales/enviar-solicitud-amistad" },
    sources: ["F21", "F34"],
  },
  {
    slug: "torneos/como-funcionan",
    category: "torneos",
    title: "Como funcionan los torneos en XIMA",
    metaDescription:
      "Resumen verificado de torneos en XIMA: salas, jugadores, partidas, posiciones y puntos pendientes.",
    h1: "Como funcionan los torneos",
    intro:
      "Los torneos son flujos competitivos visibles en XIMA, con sala, participantes y estados relacionados.",
    verified:
      "El proyecto contiene PlayTournaments, Tournament, backend de tournament y modelos de torneo.",
    usage:
      "Usa esta guia para entender el flujo general sin publicar reglas competitivas no confirmadas.",
    caution:
      "Costos, recompensas, calendario y criterios finos requieren confirmacion oficial.",
    steps: [
      "Abre Torneos desde el menu.",
      "Revisa torneos activos o futuros si aparecen.",
      "Entra a una sala disponible segun la interfaz.",
      "Observa participantes, chat o invitaciones cuando esten visibles.",
      "Juega desde la sala solo cuando la partida este lista.",
    ],
    examples: [
      "Una sala de espera puede reunir jugadores antes de iniciar.",
      "Las posiciones pueden mostrarse despues de resultados registrados.",
    ],
    faqs: [
      faq("Esta guia publica premios?", "No. Premios y costos quedan pendientes."),
      faq("Torneos y partidas independientes son iguales?", "No. Son flujos distintos dentro de XIMA."),
    ],
    links: [
      link("Torneos", "torneos"),
      link("Sala de espera", "torneos/sala-de-espera"),
      link("Posiciones", "torneos/posiciones"),
    ],
    cta: { label: "Ver torneos", path: "torneos" },
    sources: ["F16", "F32"],
    status: "partial",
  },
  {
    slug: "torneos/seguir-sala",
    category: "torneos",
    title: "Seguir una sala de torneo en XIMA",
    metaDescription:
      "Como revisar una sala de torneo en XIMA: participantes, chat, invitaciones, salida y juego desde sala.",
    h1: "Seguir sala de torneo",
    intro:
      "La sala de torneo centraliza estado antes de jugar: participantes, chat, invitaciones y acciones visibles.",
    verified:
      "Las guias existentes cubren sala de espera, chat de sala, invitar, salir y jugar desde sala.",
    usage:
      "Sigue la sala para saber si debes esperar, invitar, jugar o salir.",
    caution:
      "No publiques mensajes de chat o datos de sala privada sin permiso.",
    steps: [
      "Abre el torneo y entra a la sala disponible.",
      "Revisa participantes y estado visible.",
      "Usa chat de sala solo para coordinacion adecuada.",
      "Invita o espera segun la accion habilitada.",
      "Pulsa jugar desde sala cuando la interfaz indique que corresponde.",
    ],
    examples: [
      "Una sala puede estar esperando jugadores antes de iniciar.",
      "Salir de sala debe hacerse desde el boton oficial para evitar confusiones.",
    ],
    faqs: [
      faq("El chat de sala es publico?", "La guia no lo trata como publico; evita compartirlo fuera."),
      faq("Puedo iniciar sin jugadores?", "Depende del estado visible de la sala."),
    ],
    links: [
      link("Sala de espera", "torneos/sala-de-espera"),
      link("Chat de sala", "torneos/chat-sala"),
      link("Jugar desde sala", "torneos/jugar-desde-sala"),
    ],
    cta: { label: "Ver sala de espera", path: "torneos/sala-de-espera" },
    sources: ["F16", "F32"],
    status: "partial",
  },
  {
    slug: "torneos/revisar-recompensas",
    category: "torneos",
    title: "Recompensas de torneos en XIMA | Pendiente",
    metaDescription:
      "Pagina noindex sobre recompensas de torneos en XIMA hasta confirmar condiciones, costos y premios oficiales.",
    h1: "Revisar recompensas de torneos",
    intro:
      "El tema de recompensas de torneos necesita tratamiento prudente porque involucra condiciones competitivas y comerciales.",
    verified:
      "Existen referencias a torneos, recompensas y tienda, pero la publicacion de condiciones exige aprobacion.",
    usage:
      "Usa esta guia como marcador interno para no prometer premios no confirmados.",
    caution:
      "No publicar importes, fechas, elegibilidad ni reglas legales sin texto oficial.",
    steps: [
      "Revisa si el torneo muestra recompensa en la interfaz.",
      "Lee condiciones visibles sin asumir informacion externa.",
      "No anuncies premio si la pagina esta pendiente.",
      "Relaciona el tema con tienda solo cuando este confirmado.",
      "Mantiene noindex hasta aprobacion del propietario.",
    ],
    examples: [
      "Una referencia a recompensa no basta para prometer un premio.",
      "Un costo de torneo tambien necesita confirmacion antes de SEO.",
    ],
    faqs: [
      faq("Esta pagina entra al sitemap?", "No mientras este pendiente de confirmacion."),
      faq("Por que tanta cautela?", "Porque recompensas implican condiciones economicas y legales."),
    ],
    links: [
      link("Torneos", "torneos"),
      link("Recompensas de torneos", "torneos/recompensas"),
      link("Tienda", "tienda"),
    ],
    cta: { label: "Ver torneos", path: "torneos" },
    sources: ["F16", "F32", "F35"],
    status: "ownerConfirmation",
  },
  {
    slug: "puzzles/como-entrenar",
    category: "entrenamiento",
    title: "Como entrenar con puzzles en XIMA",
    metaDescription:
      "Aprende a entrenar con puzzles de XIMA revisando modo, objetivo, tiempo, resultado y repeticion segura.",
    h1: "Como entrenar con puzzles",
    intro:
      "Los puzzles permiten practicar posiciones concretas cuando aparecen disponibles en la interfaz.",
    verified:
      "El proyecto contiene panel de puzzles, busqueda, modos, objetivo, estados completado y fallido.",
    usage:
      "Entrena con una meta clara y revisa por que el intento termino bien o fallo.",
    caution:
      "No se publican puzzles especificos ni soluciones oficiales sin material aprobado.",
    steps: [
      "Abre Puzzles desde el lobby o menu correspondiente.",
      "Busca o selecciona un puzzle visible.",
      "Lee modo, objetivo, tiempo o turnos permitidos.",
      "Juega intentando cumplir el objetivo.",
      "Si fallas, usa Reintentar antes de pasar al siguiente.",
    ],
    examples: [
      "Un puzzle puede pedir llegar a la cima en un limite visible.",
      "Un puzzle fallido puede ser util si identificas la regla que bloqueaba la solucion.",
    ],
    faqs: [
      faq("Puzzles son partidas completas?", "Son flujos de entrenamiento, no necesariamente una partida online completa."),
      faq("Hay soluciones publicas?", "Solo deben publicarse cuando esten aprobadas."),
    ],
    links: [
      link("Puzzles", "puzzles"),
      link("Leer objetivo", "puzzles/leer-objetivo"),
      link("Reintentar puzzle", "tutoriales/reintentar-puzzle"),
    ],
    cta: { label: "Ver leer objetivo", path: "puzzles/leer-objetivo" },
    sources: ["F12", "F08"],
    status: "partial",
  },
  {
    slug: "puzzles/leer-objetivo",
    category: "entrenamiento",
    title: "Leer el objetivo de un puzzle XIMA",
    metaDescription:
      "Como interpretar objetivo, modo, turnos y tiempo de un puzzle de XIMA antes de jugarlo.",
    h1: "Leer objetivo de puzzle",
    intro:
      "El objetivo del puzzle te dice que debes lograr y bajo que limites visibles.",
    verified:
      "El panel de puzzles formatea objetivos como llegar a la cima con limites de turnos o tiempo cuando existen.",
    usage:
      "Lee el objetivo antes de mover para no resolver una posicion equivocada.",
    caution:
      "Las recompensas o condiciones especiales del puzzle necesitan confirmacion antes de publicarse.",
    steps: [
      "Abre un puzzle desde la lista.",
      "Lee el modo asociado.",
      "Revisa si hay limite de turnos o tiempo.",
      "Identifica la condicion principal, como llegar a la cima.",
      "Juega solo despues de entender el objetivo visible.",
    ],
    examples: [
      "Un objetivo puede mencionar llegar a la cima en cierta cantidad de turnos.",
      "Un limite de tiempo cambia la forma de practicar aunque las reglas base sigan aplicando.",
    ],
    faqs: [
      faq("Que hago si no entiendo el objetivo?", "Consulta reglas, modo y guia de puzzles antes de jugar."),
      faq("El objetivo cambia por modo?", "Puede relacionarse con el modo indicado en la tarjeta."),
    ],
    links: [
      link("Puzzles", "puzzles"),
      link("Modos de puzzles", "puzzles/modos"),
      link("Tiempo de puzzles", "puzzles/tiempo"),
    ],
    cta: { label: "Ver modos de puzzles", path: "puzzles/modos" },
    sources: ["F12", "F08"],
  },
  {
    slug: "puzzles/usar-recompensas",
    category: "entrenamiento",
    title: "Recompensas de puzzles en XIMA | Pendiente",
    metaDescription:
      "Pagina noindex sobre recompensas de puzzles en XIMA hasta confirmar reglas, elegibilidad y condiciones.",
    h1: "Usar recompensas de puzzles",
    intro:
      "Las recompensas de puzzles deben explicarse solo cuando existan condiciones publicas aprobadas.",
    verified:
      "El lobby contiene referencias a recompensas de puzzle y el proyecto maneja datos de reclamo en flujos relacionados.",
    usage:
      "La guia sirve para marcar el tema y evitar publicar promesas no confirmadas.",
    caution:
      "No publicar importes, stock, elegibilidad ni pasos finales de reclamo sin aprobacion.",
    steps: [
      "Revisa si el puzzle muestra recompensa visible.",
      "Lee condiciones en la interfaz oficial.",
      "No anuncies recompensa si falta confirmacion.",
      "Relaciona el tema con tienda solo cuando sea verificable.",
      "Mantiene noindex hasta texto oficial.",
    ],
    examples: [
      "Una etiqueta de recompensa no basta para publicar condiciones.",
      "Un flujo de reclamo puede requerir datos que deben protegerse.",
    ],
    faqs: [
      faq("Esta pagina esta publicada en Google?", "No. Debe quedar noindex."),
      faq("Por que?", "Porque involucra recompensas y condiciones pendientes."),
    ],
    links: [
      link("Recompensas de puzzle", "puzzles/recompensas"),
      link("Reclamar recompensa", "tienda/reclamar-recompensa"),
      link("Privacidad", "cuenta/privacidad"),
    ],
    cta: { label: "Ver puzzles", path: "puzzles" },
    sources: ["F12", "F35", "F08"],
    status: "ownerConfirmation",
  },
  {
    slug: "bots/elegir-bot",
    category: "bots",
    title: "Elegir bot en XIMA | Modo y dificultad",
    metaDescription:
      "Como elegir un bot en XIMA segun modo, dificultad visible y objetivo de practica.",
    h1: "Elegir bot",
    intro:
      "Elegir bot significa seleccionar un flujo de practica con IA segun opciones visibles.",
    verified:
      "PlayBot incluye opciones de modo y dificultad; el proyecto contiene bots para distintos modos.",
    usage:
      "Elige el bot segun lo que quieres practicar: decision libre, dados o comparacion de modos.",
    caution:
      "La guia no promete comportamiento exacto ni fuerza de cada bot.",
    steps: [
      "Abre Jugar con bot.",
      "Selecciona el modo visible que quieres practicar.",
      "Elige dificultad si la pantalla la ofrece.",
      "Inicia la partida y espera carga del tablero.",
      "Revisa la partida despues para aprender del resultado.",
    ],
    examples: [
      "Un bot de Azar ayuda a practicar decisiones con dados.",
      "Un bot de Ciencia permite concentrarse en rutas sin dados visibles.",
    ],
    faqs: [
      faq("Hay dificultad?", "La interfaz muestra dificultad en flujos de bot, pero su detalle exacto se trata con cautela."),
      faq("El bot juega igual que humano?", "No se debe afirmar eso sin validacion oficial."),
    ],
    links: [
      link("Bots", "bots"),
      link("Dificultad de bot", "bots/dificultad"),
      link("Bot no inicia", "solucion/bot-no-inicia"),
    ],
    cta: { label: "Ver bots", path: "bots" },
    sources: ["F13", "F38", "F42"],
    status: "partial",
  },
  {
    slug: "bots/practicar-ciencia",
    category: "bots",
    title: "Practicar Ciencia con bot en XIMA",
    metaDescription:
      "Guia para practicar Modo Ciencia con bot en XIMA usando decisiones libres y revision posterior.",
    h1: "Practicar Ciencia con bot",
    intro:
      "Practicar Ciencia con bot ayuda a repetir decisiones sin dados visibles en un entorno de entrenamiento.",
    verified:
      "El proyecto contiene PlayBot y componentes de ScienceBot relacionados con seleccion de movimientos.",
    usage:
      "Usa esta practica para revisar rutas, defensa, rescate y lectura de la cima.",
    caution:
      "No se debe presentar el bot como entrenador oficial certificado.",
    steps: [
      "Abre Jugar con bot.",
      "Selecciona el modo de Ciencia o equivalente visible.",
      "Elige dificultad si aparece.",
      "Juega concentrandote en una regla concreta.",
      "Revisa el resultado en historial si queda disponible.",
    ],
    examples: [
      "Puedes practicar mover en linea recta sin depender de dados.",
      "Puedes repetir defensa del bloque especial ante amenazas simples.",
    ],
    faqs: [
      faq("Es lo mismo que Ciencia online?", "Comparte reglas de modo, pero jugar contra bot no es igual a rival humano."),
      faq("Puedo usarlo para aprender?", "Si, como practica dentro del juego."),
    ],
    links: [
      link("Entrenar IA en Ciencia", "ciencia/entrenar-ia"),
      link("Modo Ciencia", "ciencia"),
      link("Elegir bot", "bots/elegir-bot"),
    ],
    cta: { label: "Ver Modo Ciencia", path: "ciencia" },
    sources: ["F13", "F38", "F41"],
    status: "partial",
  },
  {
    slug: "bots/practicar-azar",
    category: "bots",
    title: "Practicar Azar con bot en XIMA",
    metaDescription:
      "Como practicar Modo Azar con bot en XIMA leyendo dados, rutas y decisiones con riesgo.",
    h1: "Practicar Azar con bot",
    intro:
      "Practicar Azar con bot combina decisiones de tablero con lectura de dados.",
    verified:
      "El proyecto contiene PlayBot, RandomBot, dados y UI de dados para modos con azar.",
    usage:
      "Usa la practica para acostumbrarte a elegir entre rutas condicionadas por tirada.",
    caution:
      "No se explican patrones internos del bot ni estrategias garantizadas.",
    steps: [
      "Abre Jugar con bot.",
      "Selecciona Azar o el modo con dados visible.",
      "Lee la tirada cuando aparezca.",
      "Elige una ruta legal que respete dados y tablero.",
      "Revisa en replay si el movimiento fue buen riesgo.",
    ],
    examples: [
      "Una tirada alta puede ser tentadora, pero el bot puede aprovechar una pieza expuesta.",
      "Una tirada baja puede servir para mejorar posicion sin atacar.",
    ],
    faqs: [
      faq("El bot de Azar usa dados?", "El modo Azar se basa en dados; el proyecto contiene RandomBot y Dice."),
      faq("Puedo practicar sin ranking?", "La guia habla de practica, no de competicion obligatoria."),
    ],
    links: [
      link("Modo Azar", "azar"),
      link("Dados en Azar", "azar/dados"),
      link("Elegir bot", "bots/elegir-bot"),
    ],
    cta: { label: "Ver dados en Azar", path: "azar/dados" },
    sources: ["F13", "F42"],
    status: "partial",
  },
  {
    slug: "glosario/cimax",
    category: "glosario",
    title: "CIMAX | Glosario de XIMA",
    metaDescription:
      "Definicion de CIMAX en XIMA, donde aparece y como enlaza con estadisticas, ranking y progreso.",
    h1: "CIMAX",
    intro:
      "CIMAX es una metrica visible dentro de XIMA relacionada con estadisticas y modos.",
    verified:
      "El proyecto contiene componentes CIMAX, PuntuacionCimax, CimaxTracker y calculo backend cimaxScoring.",
    usage:
      "Lee CIMAX por modo y con contexto de historial, no como valor absoluto fuera del juego.",
    caution:
      "La formula completa y su explicacion publica deben mantenerse dentro de lo verificado por el proyecto.",
    steps: [
      "Abre Estadisticas.",
      "Localiza los paneles o badges CIMAX.",
      "Identifica el modo asociado al valor.",
      "Compara con partidas recientes del mismo modo.",
      "Consulta ranking solo como contexto adicional.",
    ],
    examples: [
      "CIMAX Ciencia y CIMAX Azar pueden aparecer separados.",
      "Un valor CIMAX no reemplaza el analisis de una partida.",
    ],
    faqs: [
      faq("CIMAX es un termino de XIMA?", "Si. Aparece en UI y calculos del proyecto."),
      faq("Donde aprendo mas?", "En estadisticas e interpretar CIMAX."),
    ],
    links: [
      link("Interpretar CIMAX", "estadisticas/interpretar-cimax"),
      link("Estadisticas CIMAX", "estadisticas/cimax"),
      link("Ranking", "ranking"),
    ],
    cta: { label: "Ver interpretar CIMAX", path: "estadisticas/interpretar-cimax" },
    sources: ["F19", "F47"],
    structuredDataType: "Article",
    status: "partial",
  },
  {
    slug: "glosario/replay",
    category: "glosario",
    title: "Replay | Glosario de XIMA",
    metaDescription:
      "Definicion de replay en XIMA, donde aparece y como se usa para analizar partidas.",
    h1: "Replay",
    intro:
      "Replay es la reproduccion de una partida registrada para revisar jugadas, eventos y decisiones.",
    verified:
      "XIMA contiene historial, replay, controles de velocidad, timeline y backend de datos de partida.",
    usage:
      "Usa replay para estudiar una partida despues de jugar o para mirar una partida disponible.",
    caution:
      "No todos los partidos tienen replay y no se deben publicar datos privados.",
    steps: [
      "Abre Historial o Ver partidos.",
      "Busca una tarjeta con replay disponible.",
      "Pulsa Ver replay o Reproducir.",
      "Usa controles de velocidad, pausa y timeline.",
      "Relaciona los eventos con reglas y anotacion.",
    ],
    examples: [
      "Un replay ayuda a estudiar una captura.",
      "Una tarjeta puede indicar que no hay replay guardado.",
    ],
    faqs: [
      faq("Replay y historial son iguales?", "No. Historial lista partidas; replay reproduce una partida."),
      faq("Replay siempre existe?", "No. Depende de si fue guardado."),
    ],
    links: [
      link("Historial y replay", "historial-y-replay"),
      link("Controles replay", "replay/controles"),
      link("Eventos de replay", "replay/eventos"),
    ],
    cta: { label: "Ver historial y replay", path: "historial-y-replay" },
    sources: ["F18", "F33"],
    structuredDataType: "Article",
  },
];

export const THIRD_HUNDRED_LEARN_SLUGS = THIRD_HUNDRED_TOPICS.map((topic) => topic.slug);

export const buildThirdHundredLearnPages = (deps) =>
  THIRD_HUNDRED_TOPICS.map((topic) => buildLearnPage(deps, topic));
